<template>
    <div infinite-scroll-immediate="false">
        <el-row>
            <el-col :span="this.IsCrossRegionScheduling ? 10 : 13" class="align-left line-height100 surgeryStatus">
                <i style="cursor: pointer" :class="collapse == 1 ? 'el-icon-s-unfold' : 'el-icon-s-fold'" @click="triggerCollapse()"></i>
                <i style="background: var(--primary-color, #009688)"></i><span>已排程({{ scheduledCount }})</span> <i style="background: #f44336"></i><span>进行中({{ operatingCount }})</span>
                <i style="background: #dcdfe6"></i><span>已完成({{ operatedCount }})</span> <i style="background: #78b600"></i><span>其它(清洁时间)</span>
            </el-col>
            <el-col v-show="this.IsCrossRegionScheduling" :span="this.IsCrossRegionScheduling ? 3 : 10">
                <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" placeholder="请选择区域"></item-input>
            </el-col>
            <el-col :span="11" class="align-right line-height100">
                <el-button type="primary" size="mini" v-has-permission="createapplyPermission" @click="openaddfrom">创建手术</el-button>

                <el-dropdown @command="syncSchedule" v-show="isShowDropdown">
                    <el-button type="primary" size="mini">同步<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="syncScheduleSurgery" v-has-permission="syncPermission">同步急诊手术</el-dropdown-item>
                        <el-dropdown-item command="pushSchedule" v-if="this.surgeryinfopush && this.surgeryinfopush == `true`">排程回传</el-dropdown-item>
                        <el-dropdown-item command="pushHySchedule" v-if="this.SurgerypushBtnName && this.SurgerypushBtnName != '0' && this.SurgerypushBtnName.trim() != ''">{{
                            this.SurgerypushBtnName
                        }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-button type="primary" size="mini" v-show="!isShowDropdown" v-has-permission="syncPermission" @click="syncScheduleSurgery()">同步<i class="el-icon--right"></i></el-button>
                <el-button type="primary" v-show="!isShowDropdown" v-if="this.surgeryinfopush && this.surgeryinfopush == `true`" size="mini" @click="pushSchedule()" title="手术排程回传"
                    >排程回传<i class="el-icon--right"></i
                ></el-button>
                <el-button
                    type="primary"
                    v-show="!isShowDropdown"
                    v-if="this.SurgerypushBtnName && this.SurgerypushBtnName != '0' && this.SurgerypushBtnName.trim() != ''"
                    size="mini"
                    @click="pushHySchedule()"
                    title="手术排程回传"
                    >{{ this.SurgerypushBtnName }}<i class="el-icon--right"></i
                ></el-button>

                <el-dropdown @command="cancel">
                    <el-button type="primary" size="mini" v-show="isHaveCancelSchedule(`all`)">取消驳回<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="cancelSchedule" v-show="isHaveCancelSchedule(`cancelSchedule`)">取消排程</el-dropdown-item>
                        <el-dropdown-item command="cancelSurgery" v-has-permission="cancelSurgeryPermission">取消手术</el-dropdown-item>
                        <el-dropdown-item command="rejectApprove" v-show="isHaveCancelSchedule(`rejectApprove`)">驳回审核</el-dropdown-item>
                        <el-dropdown-item command="rejectApply" v-show="isHaveCancelSchedule(`rejectApply`)">驳回申请</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="loadScheduleHelper">
                    <el-button type="primary" size="mini" v-show="ishavehelpSection(`all`)">排程助手<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="section" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpSection`)">按科室分配</el-dropdown-item>
                        <el-dropdown-item command="worker" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpWorker`)">按术者分配</el-dropdown-item>
                        <el-dropdown-item command="surgery" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpSurgery`)">按术式分配</el-dropdown-item>
                        <el-dropdown-item command="autoOneKeySchedule" v-has-permission="IntelligenceSurgeryPermission" v-show="ishavehelpSection(`helpOneKeySchedule`)">一键排程</el-dropdown-item>
                        <el-dropdown-item command="changeRoom" v-show="ishavehelpSection(`helpChangeRoom`)">更换手术间</el-dropdown-item>
                        <el-dropdown-item command="setAnesDoctor" v-show="ishavehelpSection(`helpSetAnesDoctor`)">设置麻醉医生</el-dropdown-item>
                        <el-dropdown-item command="clearWorkers" v-show="ishavehelpSection(`clearWorkersSettings`)">清除人员安排</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="printSurenry">
                    <el-button type="primary" size="mini">打印<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="item in printSurgeryConfigs" :key="item.code" v-text="item.value" :command="item"></el-dropdown-item>
                        <!-- <el-dropdown-item command="PC008">打印手术信息</el-dropdown-item>
                        <el-dropdown-item command="PC009">打印首台通知</el-dropdown-item>
                        <el-dropdown-item command="PC007">打印排程列表</el-dropdown-item> -->
                        <el-dropdown-item command="ExportExcel">导出Excel</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown @command="setup">
                    <el-button type="primary" size="mini">日历配置<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="showcardSetting">卡片设置</el-dropdown-item>
                        <el-dropdown-item command="timelinesetup">日历图设置</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </el-col>
        </el-row>
        <el-row type="flex" justify="space-between" class="toolbar-boxer height50 padding5">
            <el-col :span="6" style="display: flex; align-items: center; height: 100%">
                <item-input
                    type="select"
                    ref="selectedRoom"
                    size="small"
                    v-show="currentView == 'W' || currentView == 'M'"
                    style="height: 32px; line-height: 32px"
                    v-model="selectedRoom"
                    :options="operationRoom"
                    placeholder="请选择手术间"
                ></item-input>
            </el-col>
            <el-col :span="8" class="align-center">
                <item-input ref="datearraw2" type="datearraw2" v-show="currentView == 'D' || currentView == 'C'" v-model="rdate"></item-input>
                <el-row type="flex" align="center" v-show="currentView == 'W' || currentView == 'M'" style="padding: 0 5px; height: 40px">
                    <el-col :span="2" style="display: flex; align-items: center; height: 100%">
                        <el-button icon="el-icon-back" type="primary" plain circle @click="addDate(-1)" size="small" style="padding: 5px !important"></el-button>
                    </el-col>
                    <el-col :span="20" class="padding5 padding-none-v" style="display: flex; align-items: center; height: 100%">
                        <el-date-picker
                            ref="weekPicker"
                            style="width: 100%"
                            v-if="currentView == 'W'"
                            size="small"
                            v-model="weekValue"
                            prefix-icon=""
                            type="week"
                            :format="start + ' 至 ' + end"
                            @change="showDate"
                            :picker-options="onPicker"
                            placeholder="选择周"
                        >
                        </el-date-picker>
                        <el-date-picker style="width: 100%" size="small" v-else-if="currentView == 'M'" v-model="monthValue" prefix-icon="" type="month" format="yyyy年MM月" placeholder="选择月">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="2" style="display: flex; align-items: center; justify-content: flex-end; height: 100%">
                        <el-button icon="el-icon-right" type="primary" plain circle @click="addDate(1)" style="padding: 5px !important"></el-button>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="6" class="align-right">
                <el-button-group>
                    <el-button :type="currentView == 'C' ? 'primary' : 'plain'" size="small" @click="handleBedCardViewBtnClick">间</el-button>
                    <el-button :type="currentView == 'D' ? 'primary' : 'plain'" size="small" @click="handleTimelineDayBtnClick">日</el-button>
                    <el-button :type="currentView == 'W' ? 'primary' : 'plain'" size="small" @click="handleTimeGridWeekBtnClick">周</el-button>
                    <el-button :type="currentView == 'M' ? 'primary' : 'plain'" size="small" @click="handleDayGridMonthBtnClick">月</el-button>
                    <el-button size="small" @click="setFullScreen">{{ !fullscreen ? '全屏' : '取消全屏' }}</el-button>
                </el-button-group>
            </el-col>
        </el-row>
        <div class="my-calendar" :style="{ height: `${this.screenHeight2 - 213}px` }">
            <FullCalendar ref="myCalendar" :options="calendarOptions" v-show="currentView !== 'C'">
                <template v-slot:eventContent="arg">
                    <div v-if="arg.view.type == 'timeGridWeek'" class="padding5 padding-none-v align-left el-col el-col-24">
                        <el-row v-if="arg.event.extendedProps.isOtherEvent" class="ellipsis">
                            <el-col :span="18" class="align-left">
                                {{ arg.event.title }}
                            </el-col>
                        </el-row>
                        <el-row class="ellipsis" style="height: 20px;">
                            <el-col :span="24" class="align-right">
                                <span v-for="item in customMenuNames" :key="item.key" style="margin-left: 6px" @click.stop="windowOpen(arg.event, item)" :title="item.name">
                                    <text-formatter type="icons" v-model="item.icon" class="width50"></text-formatter>
                                </span>
                            </el-col>
                        </el-row>
                        <el-row v-if="!arg.event.extendedProps.isOtherEvent" :title="titleLabel(arg.event.extendedProps)">
                            <el-col :span="6" class="align-left">
                                {{ $moment(arg.event.start).format(`HH:mm`) }}
                            </el-col>
                            <el-col :span="18" class="align-right">
                                {{ arg.event.extendedProps.patient_name }}
                            </el-col>
                        </el-row>
                        <div class="ellipsis">{{ arg.event.extendedProps.surgeries }}</div>
                    </div>
                    <div v-else-if="arg.view.type == 'dayGridMonth'">
                        <el-row v-if="arg.event.extendedProps.isOtherEvent" class="ellipsis">
                            <el-col :span="18" class="align-left">
                                {{ arg.event.title }}
                            </el-col>
                        </el-row>
                        <el-row v-else class="ellipsis" :title="titleLabel(arg.event.extendedProps)">
                            <el-col :span="18" class="align-left overhidden">
                                {{ arg.event.extendedProps.surgeries }}
                            </el-col>
                            <el-col :span="6" class="align-center"> {{ arg.event.extendedProps.patient_name }} </el-col>
                        </el-row>
                    </div>
                    <div v-else style="height: 97%; overflow: hidden" @click="handleEventClick(arg)" @dblclick="handleEventDblClick(arg)">
                        <div
                            v-if="arg.event.extendedProps.isOtherEvent"
                            style="height: 100%; cursor: pointer"
                            class="padding5 padding-none-v align-left el-col el-col-24"
                            @dblclick="handleOtherEventDblClick(arg)"
                        >
                            <div :title="arg.event.title" style="height: 100%">
                                <el-row class="ellipsis rowheight" v-if="arg.view.type == 'resourceTimelineDay'">
                                    <el-col :span="24" class="align-right">
                                        <span class="is-circle el-icon-delete fg-info" title="删除" style="width: 14px; height: 14px; color: #fff" @click="removeotherschedule(arg.event)"></span>
                                    </el-col>
                                </el-row>
                                <el-row class="ellipsis" style="height: 20px; line-height: 20px">
                                    <div v-if="arg.view.type == 'resourceTimelineDay'">
                                        <el-col :span="24" class="align-left">{{ $moment(arg.event.start).format(`HH:mm`) }}~{{ arg.event.end && $moment(arg.event.end).format(`HH:mm`) }} </el-col>
                                    </div>
                                    <div v-if="arg.view.type == 'resourceTimeGridDay' && $moment(arg.event.end).diff($moment(arg.event.start), 'minutes') > 5">
                                        <el-col :span="20" class="align-left">{{ $moment(arg.event.start).format(`HH:mm`) }}~{{ arg.event.end && $moment(arg.event.end).format(`HH:mm`) }} </el-col>
                                        <el-col :span="4" class="align-right">
                                            <span class="is-circle el-icon-delete fg-info" title="删除" style="width: 14px; height: 14px; color: #fff" @click="removeotherschedule(arg.event)"></span
                                        ></el-col>
                                    </div>
                                </el-row>
                                <div class="ellipsis rowheight el-row">{{ arg.event.title }}</div>
                                <div v-if="isShowUserListColumn(arg.event.extendedProps.roomId)">
                                    <div class="ellipsis rowheight el-row" v-for="item in userListColumn" :key="item.key"></div>
                                </div>
                            </div>
                        </div>
                        <div v-else style="height: 100%" class="padding1 padding-none-v align-left el-col el-col-24">
                            <div v-if="arg.event.extendedProps.isShowEasyMode" :title="titleLabel(arg.event.extendedProps)" style="position: relative; height: 100%">
                                <div v-if="initialView == 'resourceTimelineDay'">
                                    <el-row class="ellipsis rowheight" style="height: 20px;">
                                        <el-col :span="24" class="align-right">
                                            <el-tag style="color: #a0bb31; border-color: #a0bb31; background-color: white" size="mini">{{ arg.event.extendedProps.enum_visit_type }}</el-tag>
                                            <el-tag
                                                class="align-left"
                                                :style="{
                                                    color: arg.event.extendedProps.enum_surgery_type > 1 ? '#2A918A' : 'red',
                                                    borderColor: arg.event.extendedProps.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C',
                                                    backgroundColor: 'white',
                                                    fontWeight: 'bold'
                                                }"
                                                size="mini"
                                                v-if="arg.event.extendedProps.surgery_type"
                                                >{{ arg.event.extendedProps.surgery_type }}</el-tag
                                            >
                                            <el-tag
                                                class="align-left"
                                                :style="{
                                                    color: '#2A918A',
                                                    borderColor: '#2A918A',
                                                    backgroundColor: 'white',
                                                    fontWeight: 'bold'
                                                }"
                                                size="mini"
                                                v-if="arg.event.extendedProps.is_day_surgery == '是' || arg.event.extendedProps.is_day_surgery == true"
                                                >日间</el-tag
                                            >
                                            <el-tag
                                                class="align-left"
                                                :style="{
                                                    color: '#2A918A',
                                                    borderColor: '#2A918A',
                                                    backgroundColor: 'white',
                                                    fontWeight: 'bold'
                                                }"
                                                size="mini"
                                                v-if="arg.event.extendedProps.is_endoscopy == '是' || arg.event.extendedProps.is_endoscopy == true"
                                                >内镜</el-tag
                                            >
                                        </el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight">
                                        <el-col :span="24" class="align-right">
                                            <span v-for="item in customMenuNames" :key="item.key" style="margin-left: 6px" @click.stop="windowOpen(arg.event, item)" :title="item.name">
                                                <text-formatter type="icons" v-model="item.icon" class="width50"></text-formatter>
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="ellipsis" style="height: 20px; line-height: 20px">
                                        <el-col :span="24" class="align-left">{{ $moment(arg.event.start).format(`HH:mm`) }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight">
                                        <el-col :span="24" class="align-left">台次:{{ arg.event.extendedProps.scheduled_sequence }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight">
                                        <el-col :span="24" class="align-left">{{ arg.event.extendedProps.patient_name }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight">
                                        <el-col :span="24" class="align-left">{{ arg.event.extendedProps.visit_no }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight">
                                        <el-col :span="24" class="align-left">{{ arg.event.extendedProps.sex }}</el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight">
                                        <el-col :span="24" class="align-left">{{ arg.event.extendedProps.age }}</el-col>
                                    </el-row>

                                    <div class="ellipsis rowheight" v-for="(item, i) in userListColumn" v-show="i < userListColumn.length - 4" :key="item.key"></div>
                                    <div class="ellipsis rightfloatcheck">
                                        <font-awesome-icon
                                            style="float: right"
                                            v-show="arg.event.extendedProps.ischecked"
                                            :icon="['fa', 'check-circle']"
                                            size="lg"
                                            :style="{ background: 'radial-gradient(red 60%,transparent 60%)' }"
                                        ></font-awesome-icon>
                                        <el-button
                                            @click.stop="downAddOtherSchedule(arg.event.extendedProps.dic_operating_room_id, arg.event.end)"
                                            icon="el-icon-bottom"
                                            v-show="arg.event.extendedProps.ischecked && arg.event.extendedProps.enum_surgery_status <= 30"
                                            circle
                                            style="float: right; padding: 0px; border: 0px; font-size: 17px; margin-right: 4px"
                                        ></el-button>
                                        <el-button
                                            @click.stop="upAddOtherSchedule(arg.event.extendedProps.dic_operating_room_id, arg.event.start)"
                                            icon="el-icon-top"
                                            v-show="arg.event.extendedProps.ischecked && arg.event.extendedProps.enum_surgery_status <= 30"
                                            circle
                                            style="float: right; padding: 0px; border: 0px; font-size: 17px; margin-right: 4px"
                                        ></el-button>
                                    </div>
                                </div>
                                <div v-else>
                                    <el-row class="ellipsis rowheight">
                                        <el-col :span="16" class="align-left" style="overflow: hidden; text-overflow: ellipsis">病人:{{ arg.event.extendedProps.patient_name }}</el-col>
                                        <el-col :span="8" class="align-right">
                                            <span v-for="item in customMenuShortNames" :key="item.key" style="margin-left: 4px" @click.stop="windowOpen(arg.event, item)" :title="item.name">
                                                <text-formatter type="icons" v-model="item.icon" class="width50"></text-formatter>
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="ellipsis rowheight">
                                        <el-col :span="24" class="align-left">手术:{{ arg.event.extendedProps.surgeries }}</el-col>
                                    </el-row>
                                    <div class="ellipsis rightfloatcheck">
                                        <font-awesome-icon
                                            style="float: right"
                                            v-show="arg.event.extendedProps.ischecked"
                                            :icon="['fa', 'check-circle']"
                                            size="lg"
                                            :style="{ background: 'radial-gradient(red 60%,transparent 60%)' }"
                                        ></font-awesome-icon>
                                        <el-button
                                            @click.stop="downAddOtherSchedule(arg.event.extendedProps.dic_operating_room_id, arg.event.end)"
                                            icon="el-icon-bottom"
                                            v-show="arg.event.extendedProps.ischecked && arg.event.extendedProps.enum_surgery_status <= 30"
                                            circle
                                            style="float: right; padding: 0px; border: 0px; font-size: 17px; margin-right: 4px"
                                        ></el-button>
                                        <el-button
                                            @click.stop="upAddOtherSchedule(arg.event.extendedProps.dic_operating_room_id, arg.event.start)"
                                            icon="el-icon-top"
                                            v-show="arg.event.extendedProps.ischecked && arg.event.extendedProps.enum_surgery_status <= 30"
                                            circle
                                            style="float: right; padding: 0px; border: 0px; font-size: 17px; margin-right: 4px"
                                        ></el-button>
                                    </div>
                                </div>
                            </div>
                            <div v-else :title="titleLabel(arg.event.extendedProps)" style="position: relative; height: 100%">
                                <el-row class="ellipsis rowheight">
                                    <el-col :span="5" class="align-left" style="padding-top: 2px">
                                        {{ $moment(arg.event.start).format(`HH:mm`) }}
                                    </el-col>
                                    <el-col :span="5" class="align-left">台次:{{ arg.event.extendedProps.scheduled_sequence }} </el-col>

                                    <el-col :span="14" class="align-right">
                                        <span v-for="item in customMenuNames" :key="item.key" style="margin-left: 6px" @click.stop="windowOpen(arg.event, item)" :title="item.name">
                                            <text-formatter type="icons" v-model="item.icon" class="width50"></text-formatter>
                                        </span>
                                    </el-col>
                                </el-row>
                                <el-row class="ellipsis">
                                    <el-col :span="12" class="align-left">
                                        <el-tag style="color: #a0bb31; border-color: #a0bb31; background-color: white" size="mini">{{ arg.event.extendedProps.enum_visit_type }}</el-tag>
                                        <el-tag
                                            class="align-left"
                                            :style="{
                                                color: arg.event.extendedProps.enum_surgery_type > 1 ? '#2A918A' : 'red',
                                                borderColor: arg.event.extendedProps.enum_surgery_type > 1 ? '#2A918A' : '#F56C6C',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }"
                                            size="mini"
                                            v-if="arg.event.extendedProps.surgery_type"
                                            >{{ arg.event.extendedProps.surgery_type }}</el-tag
                                        >
                                        <el-tag
                                            class="align-left"
                                            :style="{
                                                color: '#2A918A',
                                                borderColor: '#2A918A',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }"
                                            size="mini"
                                            v-if="arg.event.extendedProps.is_day_surgery == '是' || arg.event.extendedProps.is_day_surgery == true"
                                            >日间</el-tag
                                        >
                                        <el-tag
                                            class="align-left"
                                            :style="{
                                                color: '#2A918A',
                                                borderColor: '#2A918A',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }"
                                            size="mini"
                                            v-if="arg.event.extendedProps.is_endoscopy == '是' || arg.event.extendedProps.is_endoscopy == true"
                                            >内镜</el-tag
                                        >
                                    </el-col>
                                </el-row>
                                <div class="ellipsis rowheight">
                                    {{ arg.event.extendedProps.patient_name }}({{ arg.event.extendedProps.sex || `--` }}/{{ arg.event.extendedProps.age || `--` }}/{{
                                        arg.event.extendedProps.visit_no || `--`
                                    }}/{{ arg.event.extendedProps.outpatient_no || `--` }}/{{ arg.event.extendedProps.bed_no || `--` }}床)
                                </div>
                                <div class="ellipsis rowheight" v-for="item in userListColumn" :key="item.key">{{ item.label }}:{{ arg.event.extendedProps[item.prop] }}</div>
                                <div class="ellipsis rightfloatcheck">
                                    <font-awesome-icon
                                        style="float: right"
                                        v-show="arg.event.extendedProps.ischecked"
                                        :icon="['fa', 'check-circle']"
                                        size="lg"
                                        :style="{ background: 'radial-gradient(red 60%,transparent 60%)' }"
                                    ></font-awesome-icon>
                                    <el-button
                                        @click.stop="downAddOtherSchedule(arg.event.extendedProps.dic_operating_room_id, arg.event.end)"
                                        icon="el-icon-bottom"
                                        v-show="arg.event.extendedProps.ischecked"
                                        circle
                                        style="float: right; padding: 0px; border: 0px; font-size: 17px; margin-right: 4px"
                                    ></el-button>
                                    <el-button
                                        @click.stop="upAddOtherSchedule(arg.event.extendedProps.dic_operating_room_id, arg.event.start)"
                                        icon="el-icon-top"
                                        v-show="arg.event.extendedProps.ischecked"
                                        circle
                                        style="float: right; padding: 0px; border: 0px; font-size: 17px; margin-right: 4px"
                                    ></el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-slot:slotLabelContent="arg">
                    <div v-if="initialView == 'resourceTimelineDay'">
                        <el-row>
                            <el-col :span="24" class="align-left">{{ showSlotLabel(arg.text) }}</el-col>
                        </el-row>
                        <el-row style="height: 5px" v-if="interval == 30">
                            <el-col :span="8" style="height: 100%; border-right: 1px solid #dcdfe6"></el-col>
                            <el-col :span="8" style="height: 100%; border-right: 1px solid #dcdfe6"></el-col>
                            <el-col :span="8" style="height: 100%"></el-col>
                        </el-row>
                        <el-row style="height: 5px" v-else-if="interval == 60">
                            <el-col :span="4" style="height: 100%; border-right: 1px solid #dcdfe6"></el-col>
                            <el-col :span="4" style="height: 100%; border-right: 1px solid #dcdfe6"></el-col>
                            <el-col :span="4" style="height: 100%; border-right: 1px solid #dcdfe6"></el-col>
                            <el-col :span="4" style="height: 100%; border-right: 1px solid #dcdfe6"></el-col>
                            <el-col :span="4" style="height: 100%; border-right: 1px solid #dcdfe6"></el-col>
                            <el-col :span="4" style="height: 100%"></el-col> </el-row
                        ><el-row style="height: 5px" v-else-if="interval == 20">
                            <el-col :span="12" style="height: 100%; border-right: 1px solid #dcdfe6"></el-col>
                            <el-col :span="12" style="height: 100%"></el-col>
                        </el-row>
                    </div>
                    <div v-else>
                        <el-row>
                            <el-col :span="24" class="align-left">{{ showSlotLabel(arg.text) }}</el-col>
                        </el-row>
                    </div>
                </template>
                <template v-slot:resourceLabelContent="arg">
                    <div
                        :style="{
                            height: '100%',
                            backgroundColor: arg.resource.extendedProps.ischecked ? 'var(--primary-lighter, rgba(0, 150, 136, 0.2))' : ''
                        }"
                        @click="changeCheck(arg)"
                    >
                        <el-row class="font-size16" style="height: 22px">
                            <el-col :span="10" class="line-height20" :title="resourceLabelTitle" style="cursor: pointer">
                                {{ arg.resource.extendedProps.done }}/{{ arg.resource.extendedProps.total }}
                            </el-col>
                            <el-col :span="14" class="line-height20 align-right">
                                <span style="font-size: 14px; cursor: pointer">
                                    <i
                                        class="el-icon-message-solid"
                                        style="color: orange;"
                                        title="当前手术间未具备手术资格"
                                        @click.stop="loadCheckList(arg.resource.extendedProps)"
                                        v-show="arg.resource.extendedProps.check_result == '不合格'"
                                    ></i>
                                </span>
                                <span @click.stop="loadSettingForm(arg.resource.id, arg.resource.title, arg.resource.extendedProps)" class="hasSetting">
                                    <font-awesome-icon :icon="['fas', 'cog']"></font-awesome-icon>
                                </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <draggable
                                    v-bind="{
                                        animation: 150,
                                        group: { name: `room`, pull: 'clone', put: true },
                                        disabled: false,
                                        ghostClass: `ghost`,
                                        sort: true
                                    }"
                                    tag="div"
                                    class="align-left cursor-pointer"
                                    :component-data="getDraggleAttrs(arg.resource.id)"
                                    style="line-height: 26px; height: 26px; padding: 0 20px 0 10px; display: flex"
                                    @remove="exchangeRoom"
                                >
                                    <span class="operationRoom align-center" :span="24" :id="arg.resource.id"
                                        ><b>{{ arg.resource.title }}</b></span
                                    >
                                </draggable>
                            </el-col>
                        </el-row>
                        <el-row v-if="arg.resource.extendedProps.anesthetist && arg.resource.extendedProps.anesthetist.length > 0">
                            <el-col class="align-left" :span="24" style="font-size: 12px; margin-left: 4px"
                                >{{ T(`fullcalendar_schedule_surgery.plan_anes_doctor`) }}：{{ arg.resource.extendedProps.anesthetist }}</el-col
                            >
                        </el-row>
                        <el-row v-if="arg.resource.extendedProps.anesthetist_assistant && arg.resource.extendedProps.anesthetist_assistant.length > 0">
                            <el-col class="align-left" :span="24" style="font-size: 12px; margin-left: 4px"
                                >{{ T(`fullcalendar_schedule_surgery.plan_anes_assistants`) }}：{{ arg.resource.extendedProps.anesthetist_assistant }}</el-col
                            >
                        </el-row>
                        <el-row v-if="arg.resource.extendedProps.circuit_nurse && arg.resource.extendedProps.circuit_nurse.length > 0">
                            <el-col class="align-left" :span="24" style="font-size: 12px; margin-left: 4px"
                                >{{ T(`fullcalendar_schedule_surgery.plan_circuit_nurse`) }}：{{ arg.resource.extendedProps.circuit_nurse }}</el-col
                            >
                        </el-row>
                        <el-row v-if="arg.resource.extendedProps.equipment_nurse && arg.resource.extendedProps.equipment_nurse.length > 0">
                            <el-col class="align-left" :span="24" style="font-size: 12px; margin-left: 4px"
                                >{{ T(`fullcalendar_schedule_surgery.plan_equipment_nurse`) }}：{{ arg.resource.extendedProps.equipment_nurse }}</el-col
                            >
                        </el-row>
                    </div>
                </template>
                <template v-slot:moreLinkContent="arg">
                    <el-row class="ellipsis">+{{ arg.num }}更多</el-row>
                </template>
            </FullCalendar>
            <BedCardView ref="bedcardview" v-show="currentView == 'C'" :operationRooms="rooms" :customMenuNames="customMenuNames" :rdate="rdate"></BedCardView>
        </div>
        <el-dialog :title="autoScheduleTitle" :close-on-click-modal="false" :visible.sync="autoScheduleVisible" class="table-h560" width="90%">
            <ListView :datalist="autoScheduleSurgeries" :columns="autoScheduleColumnListBand" :buttons="autoScheduleButtons" @extrabutton-click="ExtraButtonClick"></ListView>
            <span slot="footer" class="dialog-footer">
                <el-button @click="autoScheduleVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmAutoSchedule">确 定</el-button>
            </span>
        </el-dialog>
        <cus-dialog :title="printSurenryForm.title" :visible.sync="printSurenryForm.dialogFormVisible" width="30%" @confirm="printSurenryByTime()">
            <div class="margin10 margin-none-h align-left" v-if="printSurenryForm.type == 4">
                <item-input type="multiselect" :showCount="3" :collapseTags="false" v-model="printSurenryForm.wardids" :options="operation_ward_auth" placeholder="请选择手术区"></item-input>
            </div>
            <div class="margin10 margin-none-h align-left" v-if="printSurenryForm.type == 3">
                请选择手术间：<item-input style="width: 150px" type="multiselect" v-model="printSurenryForm.roomids" :options="printSurenryForm.rooms" placeholder="请选择手术间"></item-input>
            </div>
            <div class="margin10 margin-none-h align-left">
                请 指 定 时 间：<item-input style="width: 300px" v-if="printSurenryForm.type == 5" type="datetimerange" v-model="printSurenryForm.from_to" :noPadding="true"></item-input>
                <item-input style="width: 300px" v-else type="daterange" v-model="printSurenryForm.from_to" :noPadding="true"></item-input>
            </div>
        </cus-dialog>
        <EditSurgery
            :surgeryId="edit.surgeryId"
            :visible.sync="edit.dialogFormVisible"
            :isReadOnly="edit.isReadOnly"
            :readOnlyExcludeColumns="edit.readOnlyExcludeColumns"
            @save="afterSave"
        ></EditSurgery>
        <cus-dialog :title="docinfo.title" :visible.sync="dialogFormVisible1" :footerVisible="false" width="60%" class="dialog-adverse">
            <el-row>
                <el-col :span="24" class="align-right">
                    <label style="line-height: 35px">核对人：</label>
                    <item-input
                        class="block-multi-collapse-select-width"
                        :collapseTags="true"
                        style="width: 180px"
                        type="select"
                        v-model="active_item.check_user_id"
                        :options="this.worker['护士']"
                        placeholder="核对人"
                    ></item-input>
                    <label style="padding-left: 30px; line-height: 35px">记录时间:</label>
                    <item-input
                        style="width: 180px"
                        :collapseTags="true"
                        :noPadding="true"
                        datetimeFormate="yyyy/MM/dd HH:mm"
                        type="datetime"
                        v-model="active_item.check_date"
                        placeholder="记录时间"
                    ></item-input>
                    <span style="padding-left: 30px">
                        <el-button type="primary" size="mini" plain @click="SaveChanges('合格')" style="margin-left: unset !important">核对通过</el-button>
                        <el-button type="primary" size="mini" plain @click="SaveChanges('不合格')" style="margin-left: unset !important">核对不通过</el-button>
                    </span>
                </el-col>
            </el-row>
            <DocFrame
                ref="doc"
                :guid="`checklist_${this.active_item.dic_operating_room_id}_${this.active_item.date}_SSJJC001`"
                :docno="this.$root.DOCUMENT && this.$root.DOCUMENT.SSJJC001"
                :surgeryId="0"
                @saved="afterDocSaved"
                :docname="docinfo.title"
            ></DocFrame>
        </cus-dialog>
        <AddSurgery :visible.sync="addfrom.dialogFormVisible" :defaultplanTime="addfrom.defaultplanTime" @afteradd="afteradd"> </AddSurgery>
        <cus-dialog ref="CardSetting-set" title="卡片设置" :data="cardSettingInfo" width="80%" labelWidth="200" :visible.sync="cardSettingInfo.dialogFormVisible" @confirm="SaveUserColumns">
            <el-scrollbar wrap-class="scrollbar-wrapper-x" :style="{ height: `${this.screenHeight2 - 290}px`, width: `1020px` }">
                <div style="width: 1020px">
                    <div style="float: left">
                        <div class="configcolumn" style="text-align: left"><el-row class="ellipsis"> 卡片字段选择</el-row></div>
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: `${this.screenHeight2 - 290}px`, width: `200px` }">
                            <div class="config-column">
                                <item-input type="checkboxgroup" :options="configColumns" v-model="user_config_columns"></item-input>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div style="float: left; width: 300px; height: 300px">
                        <div class="configcolumn" style="text-align: left"><el-row class="ellipsis"> 手术卡片设置</el-row></div>
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: `${this.screenHeight2 - 290}px`, width: `300px` }">
                            <div
                                class="padding5 padding-none-v align-left el-col el-col-24"
                                style="width: 300px; background-color: var(--primary-color, #33aba0); color: white; padding: 5px; border-radius: 10px; margin-top: 20px"
                            >
                                <el-row class="ellipsis">
                                    <el-col :span="6" class="align-left"> 时间 </el-col>
                                    <el-col :span="6" class="align-center"> 台次 </el-col>
                                    <el-col :span="12" class="align-right">
                                        <el-tag
                                            class="align-right"
                                            :style="{
                                                color: 'red',
                                                borderColor: '#2A918A',
                                                backgroundColor: 'white',
                                                fontWeight: 'bold'
                                            }"
                                            size="mini"
                                            >急诊</el-tag
                                        >
                                        <el-button class="btnSurgeryInfocss"><font-awesome-icon :icon="['fa', 'paper-plane']"></font-awesome-icon> ></el-button>
                                    </el-col>
                                </el-row>
                                <div class="ellipsis">姓名（性别/年龄/{{ T(`fullcalendar_schedule_surgery.visit_no`) }}/门诊号/床号）</div>
                                <div class="align-left" v-for="item in userListColumn" :key="item.key">{{ item.label }}</div>
                                <!-- <div class="ellipsis">{{ arg.event.extendedProps.surgeries }}</div>
                <div class="ellipsis">
                    {{ arg.event.extendedProps.diseases }}
                    <font-awesome-icon style="float: right" v-show="arg.event.extendedProps.ischecked" :icon="['fa', 'check-circle']"></font-awesome-icon>
                </div> -->
                            </div>
                        </el-scrollbar>
                    </div>
                    <div style="float: left; margin-left: 10px">
                        <div class="configcolumn" style="text-align: left"><el-row class="ellipsis"> 悬浮字段选择</el-row></div>
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: `${this.screenHeight2 - 290}px`, width: `200px` }">
                            <div class="config-columna">
                                <item-input type="checkboxgroup" :options="configShowColumns" v-model="user_config_showcolumns"></item-input>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div style="float: left; margin-left: 10px; width: 300px; height: 300px">
                        <div class="configcolumn" style="text-align: left"><el-row class="ellipsis"> 悬浮信息设置</el-row></div>
                        <el-scrollbar wrap-class="scrollbar-wrapper-y" :style="{ height: `${this.screenHeight2 - 290}px`, width: `300px` }">
                            <div
                                class="padding5 padding-none-v align-left el-col el-col-24"
                                style="width: 300px; background-color: #525252; color: white; padding: 5px; border-radius: 10px; margin-top: 20px"
                            >
                                <div class="ellipsis">姓名（性别/年龄/{{ T(`fullcalendar_schedule_surgery.visit_no`) }}/门诊号/床号）</div>
                                <div class="align-left" v-for="item in userListShowColumn" :key="item.key">{{ item.label }}</div>
                                <!-- <div class="ellipsis">{{ arg.event.extendedProps.surgeries }}</div>
                <div class="ellipsis">
                    {{ arg.event.extendedProps.diseases }}
                    <font-awesome-icon style="float: right" v-show="arg.event.extendedProps.ischecked" :icon="['fa', 'check-circle']"></font-awesome-icon>
                </div> -->
                            </div>
                        </el-scrollbar>
                    </div>
                </div>
            </el-scrollbar>
        </cus-dialog>
        <form-dialog :title="overrule.title" :data="overrule.data" :visible.sync="overrule.dialogFormVisible" :columns="overrule.columns" @confirm="saveOverrule"></form-dialog>
        <form-dialog
            ref="otherPlanform"
            title="添加其他排程"
            :data="otherscheduleEditData.data"
            width="50%"
            class="form-table-h360"
            labelWidth="300"
            :visible.sync="otherscheduleEditData.dialogFormVisible"
            :columns="otherscheduleEditData.ColumnList"
            @confirm="saveOtherSchedule"
        ></form-dialog>
        <form-dialog
            :title="exportExcel.title"
            :data="exportExcel.data"
            width="40%"
            :visible.sync="exportExcel.dialogFormVisible"
            :columns="exportExcel.Columns"
            @confirm="exportExcelSave"
        ></form-dialog>
        <!-- <CardSetting :visible.sync="cardSettingInfo.dialogFormVisible" ref="CardSetting" @RefreshConfigColumn="RefreshConfigColumn"></CardSetting> -->
    </div>
</template>
<script>
// 引入已经安装好的，项目中所需要的 FullCalendar 插件
import FullCalendar from '@fullcalendar/vue'
import interactionPlugin, { Draggable } from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid'
import scrollGridPlugin from '@fullcalendar/scrollgrid'
import zhcnLocale from '@fullcalendar/core/locales/zh-cn' // ⽀持中⽂
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import EditSurgery from './EditSurgery.vue'
import AddSurgery from './AddSurgery.vue'
import BedCardView from './BedCardView.vue'
import Sortable from 'sortablejs'

export default {
    name: `RightScheduleSurgery`,
    components: { FullCalendar, Draggable, draggable, EditSurgery, AddSurgery, BedCardView },
    props: {
        leftcheckedRows: Array
    },
    data() {
        let validateLength = (rule, value, callback) => {
            if (this.rejectReasons && this.rejectReasons.length > 0) {
                if (value && value.trim().length < 2) {
                    callback(new Error(`驳回理由不能少于2个字符`))
                } else {
                    callback()
                }
            } else {
                if (value && value.trim().length < 4) {
                    callback(new Error(`驳回理由不能少于4个字符`))
                } else {
                    callback()
                }
            }
        }

        // 读取 记忆设置的内容
        let memoryCondition = sessionStorage.getItem(`memory_rightCalendar`)
        let memory = null
        if (memoryCondition) {
            memory = JSON.parse(memoryCondition)
        }

        // 如果单独设置了 日历排程的 默认加载日期，就用日历排程的设置，一些医院要求：列表排程和日历排程设置的日期区分开来
        let ScheduleQueryDateOffset = this.$root.FullcalendarQueryDateOffset || this.$root.ScheduleQueryDateOffset
        let offset = (ScheduleQueryDateOffset || ``).split(`,`)
        let thirdOffSetDate = 1
        if (offset && offset.length == 3) {
            thirdOffSetDate = offset[0] // 排程日期
        }
        return {
            surgeryinfopush: this.$root.SurgeryInfoPush,
            SurgerypushBtnName: this.$root.SurgerypushBtnName,
            isEnableFilterStatusForExportExcel: this.$root.IsEnableFilterStatusForExportExcel, // 是否开启导出Excel 按状态过滤数据
            collapse: 0,
            otherScheduleIntervalTime: parseInt(
                this.$root.otherScheduleIntervalTime && this.$root.otherScheduleIntervalTime.trim() && this.$root.otherScheduleIntervalTime.trim() != `` ? this.$root.otherScheduleIntervalTime : 60
            ),
            memory: memory,
            o_dic_operating_ward_id: undefined, // 排程手术区
            issetoperatingward: false,
            scheduling_way: 1, // 排程助手  1=按科室 2=按术者 3=按术式
            operation_ward_all: undefined,
            unScheduledLength: 0, // 待排程数量
            ScheduledLength: 0, // 已排程数量
            scheduled_list: [], // 已排程列表
            autoScheduleSurgeries: [],
            autoScheduleVisible: false,
            autoScheduleColumnListBand: [],
            cardSettingInfo: {
                data: {},
                dialogFormVisible: false
            },
            printSurgeryConfigs: [],
            user_config_columns: [],
            user_config_showcolumns: [],
            configColumns: [],
            configShowColumns: [],
            tableName: `api_newSurgery/Schedule`,
            surgeryInfo: {},
            extralPageUrlMode: this.$root.ExtralPageUrlMode,
            from: this.$route.query.from,
            visitInfo: {},
            hospitalward: {},
            autoScheduleButtons: [
                {
                    // class:"is-circle",
                    label: `移除`,
                    icon: ``,
                    type: `danger`,
                    emit: `cancelAutoSchedule`,
                    permission: `default`
                }
            ],
            printSurenryForm: {
                dialogFormVisible: false,
                from_to: [],
                code: ``,
                type: `2`,
                roomids: null,
                extradata: null,
                rooms: [],
                wardids: null,
                title: `日期区间打印`
            },
            autoScheduleColumnList: [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `dic_section`,
                    label: `科室`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    isListable: true
                },

                {
                    type: `string`,
                    prop: `visit_no`,
                    label: this.T(`fullcalendar_schedule_surgery.visit_no`),
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sex`,
                    label: `性别`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `age`,
                    label: `年龄`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `bed_no`,
                    label: `床号`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgery_type`,
                    label: `手术类型`,
                    isListable: true,
                    width: `100`
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    isListable: true,
                    width: `140`
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `拟施手术`,
                    isListable: true,
                    width: `140`
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_surgeon`),
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_surgeon_assistants`),
                    isListable: true
                }
            ],
            autoScheduleUrl: { get: `/api/Preoperative/Schedule/GetAutoScheduleBySection` },
            selectedEvents: [],
            edit: {
                dialogFormVisible: false,
                surgeryId: 0,
                isReadOnly: true,
                readOnlyExcludeColumns: [`术前诊断`, `手术助手`, `年龄`, `备注`, `麻醉医生`, `麻醉助手`, `巡回护士`, `洗手护士`, `手术时间`, `预计时长`]
            },
            addfrom: {
                dialogFormVisible: false,
                defaultplanTime: this.$moment(this.rdate).format(`YYYY/MM/DD 08:00:00`)
            },
            rejectReasons: [],
            overrule: {
                title: `手术驳回`,
                dialogFormVisible: false,
                emitBtnName: ``,
                data: {},
                columns: [
                    {
                        type: `select`,
                        prop: `reject_reason`,
                        label: `驳回原因`,
                        config: {
                            allowCreate: true
                        },
                        options: this.rejectReasons,
                        validate: [
                            { validator: validateLength, trigger: `blur` },
                            { required: true, message: `必填项目`, trigger: `blur` }
                        ]
                    }
                ]
            },
            timeLineSetupInfo: null,
            interval: 0,
            initialView: ``,
            onchanged: false,
            selectedRoom: memory && memory.memory_selectedRoom ? memory.memory_selectedRoom : 0,
            rdate:
                memory && memory.memory_rdate
                    ? this.$moment(memory.memory_rdate).format(`YYYY-MM-DD`)
                    : this.$moment()
                        .add(thirdOffSetDate, `days`)
                        .format(`YYYY-MM-DD`),
            weekValue: memory && memory.memory_weekValue ? memory.memory_weekValue : ``,
            start: memory && memory.memory_start ? memory.memory_start : ``, // 起始日期
            end: memory && memory.memory_end ? memory.memory_end : ``, // 截止日期
            monthValue: memory && memory.memory_monthValue ? memory.memory_monthValue : ``,
            onPicker: {
                firstDayOfWeek: 1
            },
            dateFormate: `yyyy-MM-dd`,
            operationRoomValidation: this.$root.OperationRoomValidation,
            resourceLabelTitle: `已完成/排程总数`,
            fullscreen: false,
            calendarOptions: {
                plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, resourceTimelinePlugin, resourceTimeGridPlugin, scrollGridPlugin],
                initialView: memory && memory.memory_initialView ? memory.memory_initialView : `resourceTimeGridDay`,
                initialDate:
                    memory && memory.memory_rdate
                        ? this.$moment(memory.memory_rdate).format(`YYYY-MM-DD`)
                        : this.$moment()
                            .add(thirdOffSetDate, `days`)
                            .format(`YYYY-MM-DD`),
                locale: zhcnLocale,
                handleWindowResize: true,
                dayMaxEvents: 4,
                dayMinWidth: 200,
                headerToolbar: false,
                height: `100%`,
                views: {
                    resourceTimelineDay: {
                        buttonText: `日`
                    }
                },
                eventMinWidth: 10,
                eventMinHeight: 5,
                slotMinWidth: `120`, // 横轴模式，每个格子的宽度px,不设置自适应
                slotLabelInterval: `0:10`, // 30分钟下 一小格
                slotDuration: `0:30`, // 时间轴间隔
                slotMinTime: `00:00:00`, // 时间轴开始最小
                slotMaxTime: `24:00:00`, // 时间轴显示的最后一个时隙
                scrollTime: `08:00:00`, // 滚动轴，默认几点开始
                snapDuration: `0:10`, // 可以拖动的最新单位，10分钟
                aspectRatio: 2, // 设置日历单元格宽度与高度的比例。
                slotLabelFormat: {
                    hour: `2-digit`,
                    minute: `2-digit`,
                    omitZeroMinute: false,
                    meridiem: false,
                    hour12: false
                },
                expandRows: true,
                droppable: true,
                selectable: true,
                eventResizableFromStart: false, // 不能拖动开始改变日历大小
                noEventsMessage: `没有手术`,
                eventOrder: `scheduled_sequence`, // 按台次排序
                nowIndicator: true, // 当前时间 标记线
                resourceAreaHeaderContent: ` `,
                resourceAreaWidth: `20%`,
                resources: this.getResources,
                refetchResourcesOnNavigate: true,
                resourceOrder: `display_order`, // 按手术间排序字段 排序
                drop: this.drop, // 拖放到日历上 第一个接收事件
                allDaySlot: false, // 是否显示全天
                lazyFetching: false,
                eventOverlap: this.eventOverlap, // 是否允许事件重叠，operationRoomValidation == `1`时，不能重叠
                eventSources: [
                    // 日历数据来源
                    {
                        id: `1`,
                        events: this.getEvents, // 排程手术列表
                        eventDataTransform: this.eventDataTransform // 把手术数据 转换成 日历能识别的数据格式
                    },
                    {
                        id: `2`,
                        events: this.getOthers, // 其它清洁时间列表
                        eventDataTransform: this.othersEventDataTransform
                    }
                ],
                eventDrop: this.eventDrop, // 事件拖动事件
                eventResize: this.eventResize,
                defaultTimedEventDuration: `01:00`, // 默认加 手术时间 时长：1小时
                forceEventDuration: false,
                schedulerLicenseKey: `0469155259-fcs-1655457743`,
                eventReceive: this.eventReceive,
                eventChange: this.eventChange,
                eventDidMount: this.eventDidMount
            },
            otherscheduleEditData: {
                dialogFormVisible: false,
                data: {},
                currentClickEventEnd: null,
                currentClickPosition: null,
                ColumnList: [
                    {
                        type: `string`,
                        prop: `name`,
                        label: `名称`,
                        isCreatable: true,
                        isEditable: true,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        colspan: 24
                    },
                    {
                        type: `select`,
                        prop: `repeat_mode`,
                        label: `执行频率`,
                        isCreatable: true,
                        isEditable: true,
                        options: [
                            { label: `一次`, value: 1 },
                            { label: `每天`, value: 3 },
                            { label: `每周`, value: 4 }
                        ],
                        colspan: 24,
                        change: (that, { row, index }) => {
                            if (row.repeat_mode === 1) {
                                row.effectivetime = [this.$moment().format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD`)]
                            }
                        }
                    },
                    {
                        type: `checkboxgroup`,
                        prop: `repeat_value`,
                        label: ``,
                        options: [
                            { label: `周一`, value: `1` },
                            { label: `周二`, value: `2` },
                            { label: `周三`, value: `3` },
                            { label: `周四`, value: `4` },
                            { label: `周五`, value: `5` },
                            { label: `周六`, value: `6` },
                            { label: `周日`, value: `0` }
                        ],
                        readonly: function(that, { row, area }) {
                            return row.repeat_mode && (row.repeat_mode == 1 || row.repeat_mode == 3)
                        },
                        colspan: 24
                    },
                    {
                        type: `daterange`,
                        prop: `effectivetime`,
                        label: `有效时间`,
                        isCreatable: true,
                        isEditable: true,
                        colspan: 17,
                        default: [
                            this.$moment().format(`YYYY/MM/DD`),
                            this.$moment()
                                .add(+7, `day`)
                                .format(`YYYY/MM/DD`)
                        ]
                    },
                    {
                        type: `time`,
                        prop: `start_time`,
                        label: `开始时间`,
                        isCreatable: true,
                        isEditable: true,
                        colspan: 8,
                        default: this.$moment().format(`YYYY/MM/DD HH:mm`)
                    },
                    {
                        type: `time`,
                        prop: `end_time`,
                        label: `结束时间`,
                        isCreatable: true,
                        isEditable: true,
                        colspan: 8,
                        default: this.$moment()
                            .add(+1, `hours`)
                            .format(`YYYY/MM/DD HH:mm`)
                    },
                    {
                        type: `radio`,
                        prop: `is_limit_time`,
                        label: { content: ` `, position: `left` },
                        isCreatable: true,
                        isEditable: true,
                        readonly: false,
                        colspan: 24,
                        default: 30,
                        options: [
                            { value: 5, label: `5分钟` },
                            { value: 10, label: `10分钟` },
                            { value: 20, label: `20分钟` },
                            { value: 30, label: `30分钟` },
                            { value: 60, label: `1小时` },
                            { value: 180, label: `3小时` },
                            { value: 1440, label: `全天` }
                        ],
                        change: (that, { row, index }) => {
                            if (this.otherscheduleEditData.currentClickPosition == `UP`) {
                                if (row.is_limit_time != 1440) {
                                    row.start_time = this.$moment(row.end_time)
                                        .subtract(row.is_limit_time, `minutes`)
                                        .format(`YYYY-MM-DD HH:mm:00`)
                                } else {
                                    row.start_time = this.$moment(row.start_time).format(`YYYY-MM-DD 00:00:00`)
                                }
                            } else {
                                if (row.is_limit_time != 1440) {
                                    row.end_time = this.$moment(row.start_time)
                                        .add(row.is_limit_time, `minutes`)
                                        .format(`YYYY-MM-DD HH:mm:00`)
                                } else {
                                    row.end_time = this.$moment(row.end_time).format(`YYYY-MM-DD 23:59:00`)
                                }
                            }
                        },
                        config: { popperAppendToBody: true }
                    },
                    {
                        type: `select`,
                        prop: `tmp_operatingroom_ids`,
                        label: `手术间`,
                        showCount: 20,
                        collapseTags: false,
                        isCreatable: true,
                        isEditable: true,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        options: (that, { row }) => {
                            let data = _.filter(this.operation_ward_auth_disabled, d => {
                                return d.value == this.dic_operating_ward_id
                            })
                            let rooms =
                                _.filter(data[0] && data[0].operation_room, d => {
                                    return d.disabled === false
                                }) || []
                            return _.orderBy(rooms, `display_order`)
                        },
                        colspan: 24
                    },
                    {
                        type: `textarea`,
                        prop: `remark`,
                        label: `备注`,
                        colspan: 24,
                        config: {
                            minRows: 2
                        }
                    }
                ]
            },
            otherschedule_list: [],
            exportExcel: {
                title: `导出数据过滤`, // ACIS-23414, 手术排程，跨区域排程手术，排程助手下，增加'更换手术间'按钮
                data: {},
                exportDatas: [],
                dialogFormVisible: false,
                Columns: [
                    {
                        type: `checkboxgroup`,
                        prop: `status`,
                        label: `状态:`,
                        options: [
                            { label: `已排程`, value: `已排程` },
                            { label: `进行中`, value: `进行中` },
                            { label: `手术结束`, value: `手术结束` },
                            { label: `苏醒中`, value: `苏醒中` },
                            { label: `苏醒结束`, value: `苏醒结束` }
                        ],
                        colspan: 24,
                        default: [`已排程`, `进行中`, `手术结束`, `苏醒中`, `苏醒结束`]
                    }
                ]
            },
            scheduledCount: 0,
            operatingCount: 0,
            operatedCount: 0,
            isCollapseLeftList: !!(this.$root.IsCollapseLeftList && this.$root.IsCollapseLeftList == `1`),
            firstLoad: true, // 首次加载
            customMenuNames: [],
            timeUnit: this.$root.SurgeryTimeUnit && this.$root.SurgeryTimeUnit == `分钟` ? `minutes` : `hours`,
            defaultCostTime: 1, // 默认计时单位 1小时
            syncPermission: `emergency_surgery:sync`, // 同步 按钮权限
            createapplyPermission: `scheduling:createapply`, // 创建手术
            cancelSurgeryPermission: `scheduling:cancel_surgery`, // 取消手术
            IntelligenceSurgeryPermission: `scheduling:intelligence`, // 排程助手按钮显示权限
            drag: {
                dragElement: null, // 拖动的html元素
                dragEvent: null, // 拖动的事件
                originX: 0 // 拖动开始时的X坐标
            },
            fullcalendarLeft: 0, // 右侧日历控件距document Left的距离
            isshowCalendar: memory && memory.memory_currentView == `C` ? false : (this.$root.IsShowCalendar == `true`),
            currentView: (this.$root.IsShowCalendar == `true` ? memory && memory.memory_currentView ? memory.memory_currentView : `D` : `C`),
            rooms: [],
            active_item: {
                id: 0,
                date: null,
                dic_operating_room_id: 0,
                operating_ward: ``,
                operating_room: ``,
                check_user: {},
                check_user_id: 0,
                check_date: new Date()
            },
            docinfo: { title: `手术间检查单`, docbizid: 0 },
            dialogFormVisible1: false,
            isWorkerByDuty: this.$root.IsWorkerByDuty,
            isWarnPlanTimeDifferent: this.$root.IsWarnPlanTimeDifferent
        }
    },
    created() {
        let that = this
        this.LoadUserColumns()
        this.LoadCustomMenuNames()
        this.LoadTimeLineSetupData().then(data => {
            that.$nextTick(() => {
                let calendar = that.$refs.myCalendar.getApi()
                // 有记忆视图显示最后用户打开的日，周，月视图，没有则取 默认视图
                that.initialView = that.memory && that.memory.memory_initialView ? that.memory.memory_initialView : that.initialView
                let rdate = that.rdate
                if (that.initialView == `timeGridWeek`) {
                    // 周视图
                    if (that.memory && that.memory.memory_weekValue) {
                        rdate = that.memory.memory_weekValue
                    } else {
                        // 正常情况不会走 else
                        let weekOfDay = that.$moment().format(`E`)
                        let firstday = that
                            .$moment()
                            .subtract(weekOfDay - 1, `days`)
                            .format(`YYYY-MM-DD`)
                        rdate = firstday
                    }
                } else if (that.initialView == `dayGridMonth`) {
                    // 月视图
                    if (that.memory && that.memory.memory_monthValue) {
                        rdate = that.memory.memory_monthValue
                    } else {
                        rdate = this.monthValue = that.$moment().format(`YYYY-MM`)
                    }
                }
                calendar && calendar.changeView(that.initialView, rdate)
            })
        })
    },
    mounted() {
        let that = this
        that.loadRejectResons()
        that.loadPrintSurgeryConfig()
        that.$nextTick(() => {
            if (that.$refs.datearraw2) {
                let ele = that.$refs.datearraw2.$el
                let cls = ele.children[0].getAttribute(`class`).replace(`el-col-4`, `el-col-2`)
                ele.children[0].setAttribute(`class`, cls)
                let cls1 = ele.children[1].getAttribute(`class`).replace(`el-col-16`, `el-col-20`)
                ele.children[1].setAttribute(`class`, cls1)
                let cls2 = ele.children[2].getAttribute(`class`).replace(`el-col-4`, `el-col-2`)
                ele.children[2].setAttribute(`class`, cls2)
            }
            let mycalendar = document.querySelector(`.my-calendar`)
            let toDocLeft = mycalendar.offsetLeft
            let parent = mycalendar.offsetParent

            // while判断是否有设有定位的祖先元素
            // parent.offsetParent = null表示找到的是body,则不需要进入while
            // parent.offsetParent != null表示找到的是设有定位的祖先元素

            while (parent.offsetParent != null) {
                toDocLeft += parent.offsetLeft
                parent = parent.offsetParent
            }
            that.fullcalendarLeft = toDocLeft - 10 // 日历排程距document左侧的距离
            document.documentElement.addEventListener(`fullscreenchange`, that.handleFullscreenChange)
        })
    },
    computed: {
        ...mapGetters([
            `ward_auth`,
            `workbar`,
            `section_auth`,
            `business`,
            `currentUser`,
            `sysuser/workers_by_duty`,
            `sysuser/workers_by_dutyNew`,
            `sys_enums`,
            `active_ward`,
            `drug/drug_type`,
            `drug/drug_unit`,
            `drug/drug_way`,
            `screenHeight`,
            `screenWidth`,
            `permissions`,
            `operation_ward_auth`,
            `operation_ward_auth_disabled`,
            `otherSettingColumn`,
            `extendColumnList`
        ]),
        IsCrossRegionScheduling() {
            return _.find(this.permissions, { no: `scheduling:CrossRegionScheduling` }) != undefined
        },
        isCardRemove() {
            return _.find(this.permissions, { no: `scheduling_cardRemove` }) != undefined
        },
        isHaveCardEdit() {
            return _.find(this.permissions, { no: `scheduling_surgeryEdit` }) != undefined
        },
        isShowDropdown() {
            var check1 = _.find(this.permissions, { no: `emergency_surgery:sync` }) != undefined
            var check2 = this.surgeryinfopush && this.surgeryinfopush == `true`
            var check3 = this.SurgerypushBtnName && this.SurgerypushBtnName != `0` && this.SurgerypushBtnName.trim() != ``
            return (check1 && check2) || (check2 && check3) || (check1 && check3)
        },
        columnListLpz() {
            let list = [
                {
                    type: `select`,
                    prop: `is_day_surgery`,
                    label: `日间手术`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `enum_visit_type`,
                    label: `就诊类型`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `surgery_type`,
                    label: `手术类型`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `is_endoscopy`,
                    label: `内镜检查`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgery_status`,
                    label: `状态`,
                    width: `80`,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `dic_section`,
                    label: `科室`,
                    options: this[`section_auth`],
                    colspan: 6,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_inpatient_section`,
                    label: `病区`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_operating_room`,
                    label: `手术间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_opearting_ward`,
                    label: `手术区`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `dic_hospital_ward`,
                    label: `院区`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `diseases`,
                    label: `术前诊断`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeries`,
                    label: `拟施手术`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `plan_time`,
                    label: `计划开始时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `apply_time`,
                    label: `申请时间`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `sequence`,
                    label: `申请台次`,
                    width: `120`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_surgeon`),
                    width: `80`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `surgeon_assistants`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_surgeon_assistants`),
                    width: `120`,
                    isListable: true
                },
                {
                    // type: `multiselect`,
                    type: `string`,
                    prop: `circuit_nurse`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_circuit_nurse`),
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anaes_methods`,
                    label: `麻醉方式`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `select1`,
                    prop: `custom_status`,
                    label: `审核结果`,
                    width: `140`,
                    isListable: true
                },
                {
                    // type: `multiselect`,
                    type: `string`,
                    prop: `equipment_nurse`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_equipment_nurse`),
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `anaes_surgeon`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_anes_doctor`),
                    width: `120`,
                    isListable: true
                },
                {
                    // type: `multiselect`,
                    type: `string`,
                    prop: `anes_assistants`,
                    label: this.T(`fullcalendar_schedule_surgery.plan_anes_assistants`),
                    width: `200`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `infectious`,
                    label: `传染病`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `remark`,
                    label: `备注`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `his_remark`,
                    label: `申请备注`,
                    width: `200`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `is_local_anes_val`,
                    label: `麻醉类型`,
                    isListable: true
                }
            ] // 列表列
            if (this.surgeryinfopush == `true`) {
                list.push({
                    type: `custom`,
                    prop: `push_status`,
                    label: `回传状态`,
                    width: `120`,
                    isListable: true
                })
            }

            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, list)
            return list
        },
        listColumn() {
            let r = _.filter(this.columnListLpz, { isListable: true })
            return r
        },
        userListColumn() {
            let that = this
            if (this.configColumns.length == 0) {
                return []
            } else if (this.user_config_columns.length == 0) {
                return []
            }
            let allcolumn = _.filter(this.listColumn, c => {
                return _.includes(this.user_config_columns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })

            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configColumns, { value: ac.prop })
                return i
            })
            this.$emit(`userListColumns`, r)
            return r
        },
        userListShowColumn() {
            let that = this
            if (this.configShowColumns.length == 0) {
                return []
            } else if (this.user_config_showcolumns.length == 0) {
                return []
            }
            let allcolumn = _.filter(this.listColumn, c => {
                return _.includes(this.user_config_showcolumns, c.prop) || c.isExpand || c.isKey || (c.isDisplayOrder && c.isListable)
            })
            let r = _.orderBy(allcolumn, function(ac) {
                let i = _.findIndex(that.configShowColumns, { value: ac.prop })
                return i
            })

            let neworder = r.map((c, index) => {
                let obj = _.filter(that.configShowColumns, { value: c.prop })
                return {
                    isListable: c.isListable,
                    label: c.label,
                    prop: c.prop,
                    type: c.type,
                    width: c.width,
                    ordernum: obj[0] == null ? 0 : obj[0].ordernum
                }
            })
            let m = _.orderBy(neworder, function(o) {
                return o.ordernum
            })
            this.$emit(`userListShowColumns`, m)
            return r
        },
        dic_operating_ward_id: {
            get: function() {
                let wardid = sessionStorage.getItem(`memory_operating_ward_id`)
                if (!this.issetoperatingward && wardid) {
                    this.o_dic_operating_ward_id = wardid
                } else if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                // 上面以前逻辑不变，加上下面 记忆功能逻辑：首次加载且记忆了手术区
                this.firstLoad = false
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        worker() {
            return this[`sysuser/workers_by_duty`]
        },
        screenHeight2() {
            return this.screenHeight
        },
        operationRoom: {
            get() {
                let wardid = sessionStorage.getItem(`memory_operating_ward_id`)
                if (this.issetoperatingward || !wardid) {
                    wardid = this.dic_operating_ward_id
                }
                let data = _.filter(this.operation_ward_auth_disabled, d => {
                    return d.value == parseInt(wardid)
                })
                let rooms =
                    _.filter(data[0] && data[0].operation_room, d => {
                        return d.disabled === false
                    }) || []
                return _.orderBy(rooms, `display_order`)
            },
            set() {}
        },
        operationRoomResources: {
            get() {
                // let wardid = sessionStorage.getItem(`memory_operating_ward_id`)
                // if (this.issetoperatingward || !wardid) {
                //     wardid = this.dic_operating_ward_id
                // }
                // let data = _.filter(this.operation_ward_auth_disabled, d => {
                //     return d.value == parseInt(wardid)
                // })

                let rooms = this.calendarOptions.resources

                return _.orderBy(rooms, `display_order`)
            },
            set() {}
        },
        autoScheduleTitle() {
            return `排程助手(${this.autoScheduleSurgeries.length}/${this.unScheduledLength})`
        },
        titleLabel() {
            return function(row) {
                return this.setTitleLabel(row)
            }
        },
        // 其它时间高度是否随卡片设置字段而变化
        isShowUserListColumn() {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            return operationRoomId => {
                let show = false
                let room = calendar.getResourceById(operationRoomId)
                let events = room && room.getEvents()
                let noOtherEvents = events.filter(p => {
                    return !p.extendedProps.isOtherEvent
                })
                if (noOtherEvents && noOtherEvents.length > 0) {
                    show = true
                }
                return show
            }
        },
        customMenuShortNames() {
            let names = []
            names = this.customMenuNames && _.take(this.customMenuNames, 4)
            return names
        }
    },
    beforeDestroy() {
        // 离开页面暂存页面已设置内容，方便下次进入 记忆功能
        if (!this.$refs.myCalendar) {
            return
        }
        let calendar = this.$refs.myCalendar.getApi()
        var memoryCondition = {
            memory_currentView: this.currentView,
            memory_rdate: this.rdate,
            memory_selectedRoom: this.selectedRoom,
            // 周视图记忆
            memory_start: this.start,
            memory_end: this.end,
            memory_initialView: calendar.view.type,
            memory_weekValue: this.weekValue,
            // 月视图记忆
            memory_monthValue: this.$moment(this.monthValue).format(`YYYY-MM`)
        }
        sessionStorage.setItem(`memory_rightCalendar`, JSON.stringify(memoryCondition))
    },
    methods: {
        mousedown(ev, event) {
            let that = this
            let haveCancelSchedule = that.isHaveCancelSchedule(`cancelSchedule`)
            // 已排程状态且有取消排程权限才能拖动取消排程
            if (event.extendedProps.enum_surgery_status == 20 && haveCancelSchedule) {
                let divObj = ev.target // 找到mousedown 的元素 el
                that.drag.dragElement = divObj
                that.drag.dragEvent = event
                that.drag.originX = ev.clientX
                document.addEventListener(`mouseup`, that.dragend, false)
            }
        },
        dragend(ev) {
            let that = this
            document.removeEventListener(`mouseup`, that.dragend, false)
            let event = that.drag.dragEvent
            // 鼠标松开时的clientX 在 日历控件左侧，表示已经拖出 日历控件
            if (that.drag.originX > that.fullcalendarLeft && ev.clientX < that.fullcalendarLeft) {
                that.$confirm(`请确认是否取消(“${event.extendedProps.patient_name}”、“${event.extendedProps.visit_no || `--`}”)的排程?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                })
                    .then(() => {
                        that.dragCancelSchedule(event) // 取消排程
                    })
                    .catch(e => {})
            }
            that.drag.dragEvent = null
            that.drag.dragElement = null
            that.drag.originX = null
        },
        // 拖动取消排程
        dragCancelSchedule(event) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            that.$message.success(`取消排程调整成功`)
            return new Promise(resolve => {
                let req = this.myaxios.put(`/api/Preoperative/Schedule/CancelSchedule/${event.id}`)
                req.then(data => {
                    event && event.remove()
                    calendar.refetchResources()
                    calendar.refetchEvents()
                    that.$emit(`reloadLeftList`)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        // 向上添加其它事件
        upAddOtherSchedule(resourceId, start) {
            let that = this
            let costTimeMin = that.otherScheduleIntervalTime
            let addPrevEnd = that.$moment(start).format(`YYYY-MM-DD HH:mm:00`)
            let addPrevStart = that
                .$moment(addPrevEnd)
                .subtract(costTimeMin, `minutes`)
                .format(`YYYY-MM-DD HH:mm:00`)
            let date = that.$moment(addPrevStart).format(`YYYY-MM-DD`)
            that.otherscheduleEditData.data = {
                name: `自净`,
                repeat_mode: 1,
                effectivetime: [date, date],
                start_time: addPrevStart,
                end_time: addPrevEnd,
                is_limit_time: that.otherScheduleIntervalTime,
                tmp_operatingroom_ids: [resourceId]
            }
            this.otherscheduleEditData.currentClickEventEnd = start
            this.otherscheduleEditData.currentClickPosition = `UP`
            this.otherscheduleEditData.dialogFormVisible = true
        },
        editotherschedule(row) {
            let that = this
            that.otherscheduleEditData.currentClickEventEnd = null
            that.otherscheduleEditData.currentClickPosition = null
            row.effectivetime = []
            row.effectivetime.push(row.effective_start_time)
            row.effectivetime.push(row.effective_end_time)

            if (row.dic_operatingroom_ids != null) {
                row.tmp_operatingroom_ids = row.dic_operatingroom_ids.split(`,`).map(d => parseInt(d))
            }
            row.is_limit_time = that.otherScheduleIntervalTime
            this.otherscheduleEditData.dialogFormVisible = true
            this.otherscheduleEditData.data = row
        },
        saveOtherSchedule(row) {
            let that = this

            let calendar = that.$refs.myCalendar.getApi()
            var resource = calendar.getResourceById(row.tmp_operatingroom_ids)
            var events = resource.getEvents()
            let tmpdate = that.$moment(row.effectivetime[0]).format(`YYYY-MM-DD`)
            let tmpstartTime = that.$moment(row.start_time).format(`HH:mm`)
            let tmpendTime = that.$moment(row.end_time).format(`HH:mm`)
            let start = that.$moment(tmpdate + ` ` + tmpstartTime)
            let end = that.$moment(tmpdate + ` ` + tmpendTime)

            if (!that.otherscheduleEditData.currentClickPosition) {
                // 如果不是点击向上向下箭头弹出的界面保存，直接保存即可

                let tmpAfterEvents = events.filter(p => {
                    return p.start > start && (p.id != row.id)
                })

                let afterEvents = _.orderBy(tmpAfterEvents, `start`)
                let afterFirstEvents = afterEvents && afterEvents[0]
                if (!afterFirstEvents) {
                    // 不存在下一个相交单据 直接新增
                    that.postOtherSchedule(row)
                } else {
                    // 存在下一个数据
                    let afterFirstEventsStartTime = that.$moment(afterFirstEvents.start)
                    if (end > afterFirstEventsStartTime) {
                        if (that.operationRoomValidation && that.operationRoomValidation == `1`) {
                            that.$message.error(`当前添加事件与其它手术时间重叠，请重新调整再保存`)
                            return false
                        }
                        // 表示有相交
                        let delayMinus = end.diff(afterFirstEventsStartTime, `minutes`)
                        // 新增其它事件并顺延后面所有已排程 手术
                        that.delayAfterEvents(afterEvents, delayMinus, row)
                    } else {
                        // 不存在下一个相交单据 直接新增
                        that.postOtherSchedule(row)
                    }
                }
                return
            }

            if (that.otherscheduleEditData.currentClickPosition == `UP`) {
                // 点击向上新增其它事件
                that.saveUPAddOtherSchedule(events, row, start, end)
            } else {
                // 向下新增其它事件
                that.saveDownAddOtherSchedule(events, row, end)
            }
        },
        // 向上添加其它事件保存
        saveUPAddOtherSchedule(events, row, start, end) {
            let that = this
            let tmpBeforeEvents = events.filter(p => {
                return p.end && p.end <= that.otherscheduleEditData.currentClickEventEnd
            })

            let beforeEvents = _.orderBy(tmpBeforeEvents, `end`, `desc`)
            let beforeLastEvent = beforeEvents && beforeEvents[0]
            if (!beforeLastEvent) {
                // 不存在上一个相交单据 直接新增
                that.postOtherSchedule(row)
            } else {
                // 向上存在上一条数据,再判断上一条数据的结束时间和当前新增的事件的起始时间 是否相交
                let beforeLastEventEndTime = that.$moment(beforeLastEvent.end)
                if (start < beforeLastEventEndTime) {
                    if (that.operationRoomValidation && that.operationRoomValidation == `1`) {
                        that.$message.error(`当前添加事件与其它手术时间重叠，请重新调整再保存`)
                        return false
                    }
                    // 相交则以 上一条数据的开始时间为准
                    row.start_time = beforeLastEventEndTime

                    // 和上条手术相交了多少分钟
                    let delayMinus = beforeLastEventEndTime.diff(that.$moment(start), `minutes`)

                    row.end_time = that.$moment(end).add(delayMinus, `minutes`)

                    // 获取上条手术后面的所有手术,需要推迟的所有手术
                    let afterEvents = _.orderBy(
                        events.filter(p => {
                            return p.start >= beforeLastEvent.end
                        }),
                        `start`
                    )

                    if (afterEvents && afterEvents.length > 0) {
                        let afterFirstEvents = afterEvents[0]
                        // 存在下一个数据
                        let afterFirstEventsStartTime = that.$moment(afterFirstEvents.start)
                        if (row.end_time > afterFirstEventsStartTime) {
                            // 表示有相交
                            let delayMinus = row.end_time.diff(afterFirstEventsStartTime, `minutes`)
                            // 新增其它事件并顺延后面所有已排程 手术
                            row.start_time = that.$moment(row.start_time).format(`YYYY-MM-DD HH:mm:00`)
                            row.end_time = that.$moment(row.end_time).format(`YYYY-MM-DD HH:mm:00`)
                            that.delayAfterEvents(afterEvents, delayMinus, row)
                        } else {
                            // 不存在下一个相交单据 直接新增
                            that.postOtherSchedule(row)
                        }
                    } else {
                        that.postOtherSchedule(row)
                    }
                } else {
                    // 不存在向上相交单据，再判断是否存在向下相交，
                    that.postOtherSchedule(row)
                    // if () {

                    // } else {
                    //     that.postOtherSchedule(row)
                    // }
                }
            }
        },
        // 向下添加其它事件保存
        saveDownAddOtherSchedule(events, row, end) {
            let that = this
            let tmpAfterEvents = events.filter(p => {
                return p.start >= that.otherscheduleEditData.currentClickEventEnd
            })
            let afterEvents = _.orderBy(tmpAfterEvents, `start`)
            let afterFirstEvents = afterEvents && afterEvents[0]
            if (!afterFirstEvents) {
                // 不存在下一个相交单据 直接新增
                that.postOtherSchedule(row)
            } else {
                // 存在下一个数据
                if (end > afterFirstEvents.start) {
                    if (that.operationRoomValidation && that.operationRoomValidation == `1`) {
                        that.$message.error(`当前添加事件与其它手术时间重叠，请重新调整再保存`)
                        return false
                    }
                    // 表示有相交
                    let delayMinus = end.diff(that.$moment(afterFirstEvents.start), `minutes`)
                    // 新增其它事件并顺延后面所有已排程 手术
                    that.delayAfterEvents(afterEvents, delayMinus, row)
                } else {
                    // 不存在下一个相交单据 直接新增
                    that.postOtherSchedule(row)
                }
            }
        },
        // 推迟后面所有手术并新增其它事件
        delayAfterEvents(afterEvents, delayMinus, row) {
            let that = this
            // 存在相交单据 先提示确认后新增并推迟后面所有的手术
            this.$confirm(`存在时间重叠,当前手术间之后已排程手术申请将延迟${delayMinus}分钟,确认顺延吗?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let otherEvents = []
                let surgeryEvents = []
                afterEvents.forEach(event => {
                    if (event.extendedProps.isOtherEvent) {
                        let updateOtherEvent = {
                            id: parseInt(event.id),
                            start_time: that
                                .$moment(event.start)
                                .add(delayMinus, `minutes`)
                                .format(`YYYY-MM-DD HH:mm:00`),
                            end_time: that
                                .$moment(event.end)
                                .add(delayMinus, `minutes`)
                                .format(`YYYY-MM-DD HH:mm:00`)
                        }
                        otherEvents.push(updateOtherEvent)
                    } else {
                        let updateSurgeryEvent = {
                            id: parseInt(event.id),
                            plan_time: that
                                .$moment(event.start)
                                .add(delayMinus, `minutes`)
                                .format(`YYYY-MM-DD HH:mm:00`)
                        }
                        surgeryEvents.push(updateSurgeryEvent)
                    }
                })

                // 再推迟后面其它事件的时间
                if (otherEvents.length > 0) {
                    let req = this.myaxios.put(`/api/AcisSystem/OtherSchedule/UpdateOtherStarts`, otherEvents)
                    req.then(data => {}).catch(e => {
                        console.log(e)
                    })
                }
                // 再推迟后面手术的时间
                if (surgeryEvents.length > 0) {
                    let req = this.myaxios.put(`/api/Preoperative/Schedule/UpdateSchedulePlans`, surgeryEvents)
                    req.then(data => {}).catch(e => {
                        console.log(e)
                    })
                }
                // 新增一条其它事件
                that.postOtherSchedule(row)
            })
        },
        postOtherSchedule(row) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            row.effective_start_time = row.effectivetime.length >= 2 ? row.effectivetime[0] : ``
            row.effective_end_time = row.effectivetime.length >= 2 ? row.effectivetime[1] : ``
            row.is_limit_time = null
            if (row.repeat_value != null && row.repeat_value.indexOf(`,`) == -1 && typeof row.repeat_value != `string`) {
                row.repeat_value = row.repeat_value != null ? row.repeat_value.join(`,`) : ``
            }
            if (row.tmp_operatingroom_ids != null && row.tmp_operatingroom_ids.length > 0) {
                row.dic_operatingroom_ids = row.tmp_operatingroom_ids.join(`,`)
            }
            that.myaxios.post(`/api/AcisSystem/OtherSchedule/CreateOtherSchedule`, row).then(data => {
                calendar.refetchResources()
                calendar.refetchEvents()
                that.$emit(`reloadLeftList`)
                this.otherscheduleEditData.currentClickEventEnd = null
                this.otherscheduleEditData.currentClickPosition = null

                that.otherscheduleEditData.dialogFormVisible = false
                that.$message.success(`保存成功`)
            })
        },
        removeotherschedule(row) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    let req = this.myaxios.delete(`/api/AcisSystem/OtherSchedule/Delete/${row.id}`)
                    req.then(() => {
                        calendar.refetchResources()
                        calendar.refetchEvents()
                        that.$emit(`reloadLeftList`)
                        that.$message.success(`删除成功`)
                    })
                })
                .catch(e => {
                    console.log(e)
                })
        },
        // 向下新增其它事件
        downAddOtherSchedule(resourceId, end) {
            let that = this
            let costTimeMin = that.otherScheduleIntervalTime
            let addNextStart = that.$moment(end).format(`YYYY-MM-DD HH:mm:00`)
            let addNextEnd = that
                .$moment(addNextStart)
                .add(costTimeMin, `minutes`)
                .format(`YYYY-MM-DD HH:mm:00`)
            let date = that.$moment(addNextStart).format(`YYYY-MM-DD`)
            that.otherscheduleEditData.data = {
                name: `自净`,
                repeat_mode: 1,
                effectivetime: [date, date],
                start_time: addNextStart,
                end_time: addNextEnd,
                is_limit_time: that.otherScheduleIntervalTime,
                tmp_operatingroom_ids: [resourceId]
            }
            this.otherscheduleEditData.currentClickEventEnd = end
            this.otherscheduleEditData.currentClickPosition = `DOWN`
            this.otherscheduleEditData.dialogFormVisible = true
        },
        handleFullscreenChange(event) {
            let that = this
            that.fullscreen = !!document.fullscreenElement
            let left = document.getElementsByClassName(`el-aside cus-sider`)
            let header = document.getElementsByClassName(`el-header cus-header`)
            let tags = document.getElementById(`tags-view-container`)
            let app = document.getElementById(`app`)
            let leftexternal = document.getElementById(`external-events`)
            let rightmycalendar = document.getElementsByClassName(`my-calendar`)

            if (!document.fullscreenElement) {
                left[0].style.display = ``
                header[0].style.display = ``
                tags.style.display = ``
                // 全屏时，是否折叠左侧待排程列表只展示右侧日历界面
                if (this.isCollapseLeftList) {
                    this.collapse = 1
                    this.triggerCollapse()
                }
            } else {
                left[0].style.display = `none` // 全屏时隐藏左侧菜单
                header[0].style.display = `none` // 全屏时隐藏上侧内容
                tags.style.display = `none` // 全屏时隐藏Tab页签内容
                let iheight = app.children[0].clientHeight // 获取整个页面高度
                app.children[0].children[1].children[2].style.height = `${iheight}px` // 设置日历部分=页面高度
                leftexternal.style.height = `${iheight + 50 - 187}px` // 左侧 待办列表高度
                rightmycalendar[0].style.height = `${iheight + 50 - 150}px` // 右侧 日历高度
            }
        },
        ishavehelpSection(permiskey) {
            if (permiskey != `all`) {
                return this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:${permiskey}`) != -1
            } else {
                return (
                    this.permissions &&
                    this.permissions.findIndex(
                        item =>
                            item.permission === `scheduling:helpSection` ||
                            item.permission === `scheduling:helpWorker` ||
                            item.permission === `scheduling:helpSurgery` ||
                            item.permission === `scheduling:helpChangeRoom` ||
                            item.permission === `scheduling:helpSetAnesDoctor` ||
                            item.permission === `scheduling:helpOneKeySchedule` ||
                            item.permission === `scheduling:clearWorkersSettings`
                    ) != -1
                )
            }
        },
        isHaveCancelSchedule(permiskey) {
            if (permiskey != `all`) {
                return this.permissions && this.permissions.findIndex(item => item.permission === `scheduling:${permiskey}`) != -1
            } else {
                return (
                    this.permissions &&
                    this.permissions.findIndex(
                        item => item.permission === `scheduling:cancelSchedule` || item.permission === `scheduling:rejectApprove` || item.permission === `scheduling:rejectApply`
                    ) != -1
                )
            }
        },
        // 周视图 设置时间
        showDate() {
            let that = this
            let weekOfDay = that.$moment(this.weekValue).format(`E`)
            let firstday = that
                .$moment(this.weekValue)
                .subtract(weekOfDay - 1, `days`)
                .format(`YYYY-MM-DD`)
            let endday = that
                .$moment(this.weekValue)
                .subtract(weekOfDay - 7, `days`)
                .format(`YYYY-MM-DD`)
            this.start = firstday
            this.end = endday
        },
        // 上一周，下一周，上一月，下一月，日视图不调用这个
        addDate(prevOrNext) {
            let that = this
            if (that.currentView == `W`) {
                let prev = that
                    .$moment(this.weekValue)
                    .subtract(-prevOrNext, `week`)
                    .startOf(`week`)
                    .format(`YYYY-MM-DD`)
                let next = that
                    .$moment(this.weekValue)
                    .subtract(-prevOrNext, `week`)
                    .endOf(`week`)
                    .format(`YYYY-MM-DD`)
                this.weekValue = prev
                this.start = prev
                this.end = next
            }
            if (that.currentView == `M`) {
                let month = that.$moment(this.monthValue).subtract(-prevOrNext, `month`)
                this.monthValue = month
            }
        },
        setTitleLabel(row) {
            let that = this
            var title = `${row.patient_name}(${row.sex || `--`}/${row.age || `--`}/${row.visit_no || `--`}/${row.bed_no || `--`}床)\n`
            var columns = that.userListShowColumn
            _.each(columns, item => {
                title += `${item.label}:${row[item.prop] || ``}\n`
            })
            return title
        },
        changeClass(item) {
            if (item) {
                let calendar = this.$refs.myCalendar.getApi()
                var event = calendar.getEventById(item.id)
                if (event) {
                    var classData = []
                    if (event.classNames.length != 0) {
                        classData = event.classNames
                        if (classData.indexOf(`shine`) >= 0) {
                            // 存在要设置的样式，则不再往数组中添加；
                            return
                        }
                    }
                    classData.push(`shine`)
                    event.setProp(`classNames`, classData)
                }
            }
        },
        updateClass(item) {
            if (item) {
                let calendar = this.$refs.myCalendar.getApi()
                var event = calendar.getEventById(item.id)
                if (event) {
                    var classData = []
                    if (event.classNames.length != 0) {
                        classData = event.classNames.filter(function(classItem) {
                            return classItem != `shine`
                        })
                    }
                    event.setProp(`classNames`, classData)
                }
            }
        },
        // 床位卡 视图
        handleBedCardViewBtnClick() {
            this.isshowCalendar = false
            this.currentView = `C`
        },
        // 点击 日 视图
        handleTimelineDayBtnClick() {
            let that = this
            that.isshowCalendar = true
            let calendar = this.$refs.myCalendar.getApi()
            this.initialView = that.timeLineSetupInfo && that.timeLineSetupInfo.model == 1 ? `resourceTimelineDay` : `resourceTimeGridDay`
            that.currentView = `D`
            let initialDate = that.$moment(that.rdate).format(`YYYY-MM-DD`)
            calendar.changeView(this.initialView, initialDate)
            that.selectedRoom = 0
        },
        // 点击 周 视图
        handleTimeGridWeekBtnClick() {
            let that = this
            that.isshowCalendar = true
            let calendar = this.$refs.myCalendar.getApi()
            let weekOfDay = that.$moment().format(`E`)
            let firstday = that
                .$moment()
                .subtract(weekOfDay - 1, `days`)
                .format(`YYYY-MM-DD`)
            let endday = that
                .$moment()
                .subtract(weekOfDay - 7, `days`)
                .format(`YYYY-MM-DD`)
            this.weekValue = firstday
            this.start = firstday
            this.end = endday
            that.currentView = `W`
            that.selectedRoom = that.operationRoom && that.operationRoom[0].value
            calendar.changeView(`timeGridWeek`, firstday)
        },
        // 点击 月 视图
        handleDayGridMonthBtnClick() {
            let that = this
            that.isshowCalendar = true
            let calendar = this.$refs.myCalendar.getApi()
            that.currentView = `M`
            this.monthValue = that.$moment().format(`YYYY-MM`)
            that.selectedRoom = that.operationRoom && that.operationRoom[0].value
            calendar.changeView(`dayGridMonth`)
        },
        setFullScreen() {
            if (!document.fullscreenElement) {
                this.collapse = 0
                document.documentElement.requestFullscreen()
            } else if (document.exitFullscreen) {
                this.collapse = 1
                document.exitFullscreen()
            }
            // 全屏时，是否折叠左侧待排程列表只展示右侧日历界面
            if (this.isCollapseLeftList) {
                this.triggerCollapse()
            }
        },
        // 拿到设置后，对calendar进行设置
        gettimeLineSetupInfo(data) {
            let that = this
            that.timeLineSetupInfo = data
            that.interval = data.interval
            that.$nextTick(() => {
                let calendar = that.$refs.myCalendar.getApi()
                let setupDefaultTime = that.timeLineSetupInfo && that.timeLineSetupInfo.defaultTimed_event_duration ? that.timeLineSetupInfo.defaultTimed_event_duration : 60
                calendar.setOption(`defaultTimedEventDuration`, `00:${setupDefaultTime}`)
                that.defaultCostTime = that.timeUnit == `hours` ? _.round(setupDefaultTime / 60, 2) : setupDefaultTime // 此参数依赖 defaultTimedEventDuration，目前 设置的是1小时
                let start = data && data.available_start_time ? that.$moment(data.available_start_time).format(`HH:mm`) : `00:00:00`
                let end = data && data.available_end_time ? that.$moment(data.available_end_time).format(`HH:mm`) : `23:59:00`
                let scrollFirstTime = data && data.first_show_time ? that.$moment(data.first_show_time).format(`HH:mm`) : `08:00:00`
                let interval = ``
                switch (data && data.interval) {
                case 10:
                    interval = `00:10:00`
                    break
                case 20:
                    interval = `00:20:00`
                    break
                case 30:
                    interval = `00:30:00`
                    break
                case 60:
                    interval = `1:00:00`
                    break
                default:
                    interval = `1:00:00`
                    break
                }
                calendar.setOption(`slotDuration`, interval)
                if (data && (data.interval == 60 || data.interval == 30 || data.interval == 20)) {
                    calendar.setOption(`slotMinWidth`, 120)
                } else {
                    calendar.setOption(`slotMinWidth`, 60)
                }
                calendar.setOption(`slotMinTime`, start)
                calendar.setOption(`slotMaxTime`, end)
                calendar.setOption(`scrollTime`, scrollFirstTime)
                calendar.setOption(`slotLabelInterval`, interval)
                calendar.scrollToTime(scrollFirstTime)
                this.initialView = data && data.model == 1 ? `resourceTimelineDay` : `resourceTimeGridDay`
            })
        },
        // 更换手术间
        showChangeRoom(surgerys) {
            this.$emit(`showchangeRoom`, surgerys)
        },
        // 跨区域排程调用
        getchangeRoomSave(row, surgeryIds) {
            let that = this
            let currentDate = that.getCurrentDate()
            let date = that.$moment(currentDate).format(`YYYY-MM-DD`)
            if (row.status == 10) {
                // 新申请的，走新申请 调用存储过程分配手术间逻辑
                that.ScheduleSurgeries(date, row.dic_operating_room_id, surgeryIds)
            } else {
                // 已排程的走更换手术间逻辑
                that.changeRoomSave(date, row.dic_operating_room_id, row.dic_recovery_ward_id, surgeryIds)
            }
        },
        changeRoomSave(date, operatingRoomId, recoveryWardId, surgeryIds) {
            let that = this
            // added by xiaorui,2022-04-05 ,ACIS-23414,手术排程，跨区域排程手术，排程助手下，增加'更换手术间'按钮
            if (surgeryIds.length > 0) {
                let req = that.myaxios.put(`/api/Preoperative/Schedule/ChangeRoom?operatingRoomId=${operatingRoomId}&operatingWardId=${recoveryWardId}&date=${date}`, surgeryIds)
                req.then(data => {
                    that.refetch()
                    that.$emit(`reloadLeftList`)
                    that.$message.success(`保存成功`)
                }).catch(e => {
                    that.$message.error(`更换手术间失败`)
                })
            }
        },
        showSetAnesDoctor(surgeryIds) {
            this.$emit(`showSetAnesDoctor`, surgeryIds)
        },
        showClearWorkersForm(surgeryIds) {
            this.$emit(`showClearWorkersForm`, surgeryIds)
        },
        setAnesDoctorSave(row) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            if (row.surgeryIds.length > 0) {
                let req = that.myaxios.put(`/api/Preoperative/Schedule/SetAnesDoctorSurgeries?plan_anes_doctor=${row.plan_anes_doctor.value}`, row.surgeryIds)
                req.then(data => {
                    calendar.refetchResources()
                    calendar.refetchEvents()
                    that.$emit(`reloadLeftList`)
                    that.$message.success(`保存成功`)
                }).catch(e => {
                    that.$message.error(`设置麻醉医生失败`)
                })
            }
        },
        timelinesetup() {
            this.$emit(`showTimeLineSetup`)
        },
        getEvents(fetchInfo, successCallback, failureCallback) {
            let that = this
            let start = this.$moment(fetchInfo.start).format(`YYYY-MM-DD`)
            let end = this.$moment(fetchInfo.end).format(`YYYY-MM-DD`)
            that.selectedEvents = []
            that.$nextTick(() => {
                let calendar = that.$refs.myCalendar.getApi()
                calendar.getEvents().forEach(e => {
                    e.remove()
                })
            })
            return new Promise(resolve => {
                // 获取已排程
                let req = this.myaxios.getNoloading(`/api/Preoperative/Schedule/GetSampleCalendarScheduled?searchType=2&begin=${start}&end=${end}`)
                req.then(data1 => {
                    if (that.currentView == `W` || that.currentView == `M`) {
                        data1 = _.filter(data1, { dic_operating_room_id: that.selectedRoom })
                    }
                    // 按手术区过滤数据
                    if (this.dic_operating_ward_id != undefined) {
                        data1 = _.filter(data1, { dic_operating_ward_id: parseInt(this.dic_operating_ward_id) })
                    }
                    this.scheduledCount = this.operatingCount = this.operatedCount = 0
                    // 获取已排程、手术中、手术结束的数量
                    this.scheduledCount = _.filter(data1, { enum_surgery_status: 20 }).length
                    this.operatingCount = _.filter(data1, { enum_surgery_status: 30 }).length
                    this.operatedCount = _.filter(data1, p => {
                        return p.enum_surgery_status >= 40
                    }).length

                    let r1 = data1.map(d => {
                        d.class_name = d.enum_surgery_status > 20 ? `ignore-drag` : ``
                        d.drag_html = `<div><b>${d.patient_name}</b>(${d.sex || `--`}/${d.age || `--`}/${d.visit_no || `--`}/${d.dic_section || `--`} ${d.bed_no || `--`}床)</div>`
                        d.ischecked = false
                        // reload的时候把动态列字段放到obj对象里面
                        this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)
                        _.each(d, (value, key) => {
                            /* eslint valid-typeof: "error" */
                            if (typeof d[key] == `boolean` && key != `ischecked`) {
                                if (d[key] == true) {
                                    d[key] = `是`
                                } else {
                                    d[key] = `否`
                                }
                            } else if (d[key] && (d[key] + ``).indexOf(`/Date`) > -1) {
                                d[key] = this.$moment(d[key]).format(`YYYY/MM/DD HH:mm`)
                            } else if (key == `enum_visit_type`) {
                                if (d[key] == 1) {
                                    d[key] = `住院`
                                } else if (d[key] == 2) {
                                    d[key] = `门诊`
                                } else if (d[key] == 3) {
                                    d[key] = `体检`
                                } else {
                                    d[key] = ``
                                }
                            }
                        })
                        return d
                    })
                    that.scheduled_list = r1
                    resolve(r1)
                })
            })
        },
        getOthers(fetchInfo, successCallback, failureCallback) {
            let that = this
            let s = this.$moment(fetchInfo.start).format(`YYYY-MM-DD`)
            let end = this.$moment(fetchInfo.end).format(`YYYY-MM-DD`)

            return new Promise(resolve => {
                let req = that.myaxios.getNoloading(`/api/AcisSystem/OtherSchedule/GetByDateRange?begin=${s}&end=${end}`)
                req.then(data => {
                    data = data.map(d => {
                        d.checked = false
                        return d
                    })
                    that.otherschedule_list = data
                    let allEvents = []
                    let startDate = this.$moment(fetchInfo.start)
                    let endDate = this.$moment(fetchInfo.end)
                    let starttmp = startDate

                    while (starttmp < endDate) {
                        let start = this.$moment(starttmp).format(`YYYY-MM-DD`)
                        _.forEach(data, function(item) {
                            if (item.repeat_mode == 1) {
                                let startday = that.$moment(item.effective_start_time).format(`YYYY-MM-DD`)
                                if (start != startday) {
                                    return
                                }
                            }

                            if (item.repeat_mode == 3 || item.repeat_mode == 4) {
                                let firstday = that.$moment(item.effective_start_time).format(`YYYY-MM-DD`)
                                let endday = that.$moment(item.effective_end_time).format(`YYYY-MM-DD`)
                                if (start < firstday || start > endday) {
                                    return
                                }

                                if (item.repeat_mode == 4) {
                                    if (item.repeat_value != null) {
                                        let weekdays = item.repeat_value.split(`,`).map(d => parseInt(d))
                                        let currentDay = that.$moment(starttmp).day()
                                        if (_.indexOf(weekdays, currentDay) == -1) {
                                            return
                                        }
                                    }
                                }
                            }

                            if (item.dic_operatingroom_ids != null) {
                                let operatingroomIds = item.dic_operatingroom_ids.split(`,`).map(d => parseInt(d))
                                let startTime = null
                                let endTime = null
                                _.forEach(operatingroomIds, function(roomId) {
                                    let tmpstart = that.$moment(item.start_time).format(`HH:mm`)
                                    startTime = that.$moment(start + ` ` + tmpstart).format(`YYYY-MM-DD HH:mm`)
                                    let tmpend = item.end_time && that.$moment(item.end_time).format(`HH:mm`) || ``
                                    endTime = tmpend ? that.$moment(start + ` ` + tmpend).format(`YYYY-MM-DD HH:mm`) : null
                                    let c = {
                                        id: item.id,
                                        title: item.name,
                                        groupId: item.id,
                                        is_limit_time: item.is_limit_time,
                                        effective_start_time: that.$moment(item.effective_start_time).format(`YYYY-MM-DD HH:mm`),
                                        effective_end_time: that.$moment(item.effective_end_time).format(`YYYY-MM-DD HH:mm`),
                                        start_time: startTime,
                                        end_time: endTime,
                                        roomId: roomId,
                                        isOtherEvent: true
                                    }
                                    allEvents.push(c)
                                })
                            }
                        })
                        starttmp = starttmp.add(1, `days`)
                    }

                    if (that.currentView == `W` || that.currentView == `M`) {
                        allEvents = _.filter(allEvents, { roomId: that.selectedRoom })
                    }
                    resolve(allEvents)
                }).catch(e => {})
            })
        },
        eventDataTransform(eventData) {
            let that = this
            let bgcolor = ``
            let color = ``
            let editable = false
            switch (eventData.enum_surgery_status) {
            case 20:
                bgcolor = this.$getThemePrimaryColor()
                color = `#ffffff`
                editable = true
                break
            case 30:
                bgcolor = `#f44336`
                color = `#ffffff`
                editable = false
                break
            case 40:
                bgcolor = `#dcdfe6`
                color = `#333333`
                editable = false
                break
            default:
                bgcolor = `#dcdfe6`
                color = `#333333`
                editable = false
            }

            let start = ``
            let end = ``
            if (that.currentView == `M` || that.currentView == `W`) {
                editable = false
            }
            if (that.currentView == `M`) {
                start = that.$moment(eventData.plan_time).format(`YYYY-MM-DD`)
                end = start
            } else {
                let calendar = this.$refs.myCalendar.getApi()
                start = that.$moment(eventData.plan_time).format(`YYYY-MM-DD HH:mm:00`)

                let costTime = 0
                if (eventData.cost_time && eventData.cost_time > 0) {
                    costTime = _.round(eventData.cost_time, 2)
                } else {
                    // 获取默认时长
                    costTime = that.defaultCostTime
                }

                // 按分钟还是按小时计算结束时间
                end = that
                    .$moment(eventData.plan_time)
                    .add(costTime, that.timeUnit)
                    .format(`YYYY-MM-DD HH:mm:00`)
                // 按分钟直接返回分钟数 按小时 *60
                let longMins = that.timeUnit == `minutes` ? costTime : _.round(costTime * 60)

                let slotDuration = calendar.getOption(`slotDuration`)
                let interval = 0
                switch (slotDuration) {
                case `00:10:00`:
                    interval = 10
                    break
                case `00:20:00`:
                    interval = 20
                    break
                case `00:30:00`:
                    interval = 30
                    break
                case `1:00:00`:
                    interval = 60
                    break
                default:
                    interval = 60
                    break
                }

                // 时长小于一个单元格时，显示简易模式
                if (longMins <= interval) {
                    eventData.isShowEasyMode = true
                } else {
                    eventData.isShowEasyMode = false
                }
            }

            // 卡片移动权限判断
            if (!that.isCardRemove) {
                editable = false
            }

            let data = {
                id: eventData.id,
                title: eventData.drag_html,
                resourceId: eventData.dic_operating_room_id,
                start: start,
                color: bgcolor,
                textColor: color,
                end: end,
                startEditable: editable,
                durationEditable: editable,
                resourceEditable: editable,
                editable: editable,
                eventInteractive: true,
                extendedProps: eventData
            } // 可以拖动、缩放
            return data
        },
        othersEventDataTransform(eventData) {
            let that = this
            let bgcolor = `#78b600`
            let color = `#ffffff`
            let allDay = false
            let className = ``
            if (that.currentView == `M`) {
                eventData.start_time = that.$moment(eventData.start_time).format(`YYYY-MM-DD`)
                eventData.end_time = eventData.start_time
                allDay = true
            } else {
                if (that.currentView == `D`) {
                    className = `otherEventClass`
                }
            }
            let data = {
                id: eventData.id,
                title: eventData.title,
                resourceId: eventData.roomId,
                allDay: allDay,
                start: eventData.start_time,
                end: eventData.end_time,
                color: bgcolor,
                textColor: color,
                classNames: className,
                startEditable: false,
                durationEditable: false,
                resourceEditable: false,
                editable: false,
                eventInteractive: true,
                extendedProps: eventData
            } // 可以拖动、缩放
            return data
        },
        eventOverlap(stillEvent, movingEvent) {
            let that = this
            if (that.operationRoomValidation && that.operationRoomValidation == `1`) {
                return false
            } else {
                return true
            }
        },
        drop(dropInfo) {},
        getCurrentDate() {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            return calendar.getDate()
        },
        getCalendarApi() {
            let that = this
            return that.$refs.myCalendar.getApi()
        },
        getOperationRooms(date) {
            let that = this
            return new Promise(resolve => {
                let req = this.myaxios.getNoloading(`/api/Preoperative/Schedule/GetRooms`, { date: date })
                req.then(data => {
                    that.operation_ward_all = _.groupBy(data, `dic_operating_ward_id`)

                    let tmp = this.operation_ward_all && this.operation_ward_all[parseInt(this.dic_operating_ward_id)]
                    tmp = _.orderBy(tmp, `display_order`) || []
                    let r = tmp.map(d => {
                        let c = {
                            id: d.id,
                            title: d.name,
                            done: d.done,
                            total: d.total,
                            anesthetist: (d.room_setting && d.room_setting.anesthetist) || ``,
                            anesthetistObj: (d.room_setting && d.room_setting.anesthetistObj) || null,
                            anesthetist_id: (d.room_setting && d.room_setting.anesthetist_id) || null,
                            anesthetist_assistant: (d.room_setting && d.room_setting.anesthetist_assistant) || ``,
                            anesthetist_assistant_id: (d.room_setting && d.room_setting.anesthetist_assistant_id) || null,
                            anesthetist_assistantsObj: (d.room_setting && d.room_setting.anesthetist_assistantsObj) || null,
                            surgeon_name: (d.room_setting && d.room_setting.surgeon_name) || ``,
                            surgeonObj: (d.room_setting && d.room_setting.surgeonObj) || null,
                            surgeon_id: (d.room_setting && d.room_setting.surgeon_id) || null,
                            dic_surgery_name: (d.room_setting && d.room_setting.dic_surgery_name) || ``,
                            circuit_nurse: (d.room_setting && d.room_setting.circuit_nurse) || ``,
                            circuit_nurse_id: (d.room_setting && d.room_setting.circuit_nurse_id) || null,
                            dic_operating_room: (d.room_setting && d.room_setting.dic_operating_room) || null,
                            dic_operating_room_id: (d.room_setting && d.room_setting.dic_operating_room_id) || null,
                            dic_section_id: (d.room_setting && d.room_setting.dic_section_id) || null,
                            dic_section_name: (d.room_setting && d.room_setting.dic_section_name) || null,
                            dicSectionObj: (d.room_setting && d.room_setting.dicSectionObj) || null,
                            display_order: d.display_order || 0,
                            equipment_nurse: (d.room_setting && d.room_setting.equipment_nurse) || null,
                            equipment_nurse_id: (d.room_setting && d.room_setting.equipment_nurse_id) || null,
                            room_setting_id: (d.room_setting && d.room_setting.id) || 0,
                            check_result: (d.room_setting && d.room_setting.check_result) || `未检查`,
                            room_setting: d.room_setting,
                            ischecked: false
                        }
                        return c
                    })
                    resolve(r)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        getResources(fetchInfo, successCallback, failureCallback) {
            let that = this
            let start = that.$moment(fetchInfo.start).format(`YYYY/MM/DD HH:mm:00`)
            return new Promise(resolve => {
                that.getOperationRooms(start)
                    .then(data => {
                        this.rooms = data
                        resolve(data)
                    })
                    .catch(e => {
                        console.log(e)
                    })
            })
        },
        eventDrop: function(eventDropInfo) {
            let that = this
            that.onchanged = true
        },
        eventResize: function(eventResizeInfo) {
            let that = this
            that.onchanged = true
        },
        eventDidMount: function(arg) {
            let that = this
            that.$nextTick(() => {
                let isOtherEvent = arg.event.extendedProps.isOtherEvent
                let divObj = arg.el
                let event = arg.event
                // 监控鼠标的mousedown 事件，通过 mousedown mousemove,mouseup 组合拖拽
                divObj.addEventListener(
                    `mousedown`,
                    function(ev) {
                        that.mousedown(ev, event)
                    },
                    false
                )
                if (isOtherEvent) {
                    // 当前手术间如果只设置了其它事件，没有手术事件，则其它事件高度不随卡片设置字段变化高度
                    let calendar = that.$refs.myCalendar.getApi()
                    let roomId = arg.event.extendedProps.roomId
                    let show = false
                    let room = calendar.getResourceById(roomId)
                    let events = room && room.getEvents()
                    let noOtherEvents = events.filter(p => {
                        return !p.extendedProps.isOtherEvent
                    })
                    if (noOtherEvents && noOtherEvents.length > 0) {
                        show = true
                    }
                    if (!show) {
                        let cellHeight = arg.el.parentElement.parentElement.parentElement.parentElement.offsetHeight
                        arg.el.style.height = `${cellHeight - 10}px`
                    }
                }
            })
        },
        eventChange: function(arg) {
            let that = this
            if (!that.onchanged) {
                return false
            }

            let resources = arg.event.getResources()
            let newRoomId = resources && resources[0].id

            let oldResources = arg.oldEvent.getResources()
            let oldRoomId = oldResources && oldResources[0].id

            const duration = that.$moment.duration(that.$moment(arg.event.end).diff(that.$moment(arg.event.start)))
            let costTime = that.timeUnit == `minutes` ? _.round(duration.asMinutes()) : _.round(duration.asHours(), 2)
            let r = {
                oldRoomId: oldRoomId,
                newRoomId: newRoomId,
                planTime: that.$moment(arg.event.start).format(`YYYY-MM-DD HH:mm`),
                costTime: costTime
            }
            let surgeryIds = []
            surgeryIds.push(arg.event.id)
            // 获取已排程
            let req = that.myaxios.put(
                `api/Preoperative/Schedule/ModifySchedulePlanAndCostTime?oldRoomId=${r.oldRoomId}&newRoomId=${r.newRoomId}&planTime=${r.planTime}&costTime=${r.costTime}`,
                surgeryIds
            )
            req.then(data1 => {
                let calendar = that.$refs.myCalendar.getApi()
                that.onchanged = false
                calendar.refetchResources()
                calendar.refetchEvents()
                that.$emit(`reloadLeftList`)
                that.$message.success(`手术排程调整成功`)
            })
        },
        eventReceive: function(arg) {
            let that = this
            let plantime = that.$moment(arg.event.extendedProps.plan_time).format(`YYYY-MM-DD`)
            let toplantime = that.$moment(that.rdate).format(`YYYY-MM-DD`)
            if (plantime != toplantime && this.isWarnPlanTimeDifferent == `1`) {
                return that.$confirm(`当前安排手术时间与该患者计划手术时间:${plantime}不一致,是否继续?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                })
                    .then(() => {
                        that.wardPlanfun(arg)
                    })
                    .catch(e => {
                        let calendar = that.$refs.myCalendar.getApi()
                        calendar.refetchResources()
                        calendar.refetchEvents()
                    })
            } else {
                that.wardPlanfun(arg)
            }
        },
        wardPlanfun: function(arg) {
            let that = this
            let msgs = ``
            if (arg.event.extendedProps && arg.event.extendedProps.dic_operating_ward_id != parseInt(that.dic_operating_ward_id)) {
                msgs = `(“${arg.event.extendedProps.patient_name}”、“${arg.event.extendedProps.visit_no || `--`}”)`
            }
            if (msgs != ``) {
                return that
                    .$confirm(`请确认${msgs}是否跨区排程?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                    .then(() => {
                        that.receivefun(arg)
                    })
                    .catch(e => {
                        let calendar = that.$refs.myCalendar.getApi()
                        calendar.refetchResources()
                        calendar.refetchEvents()
                    })
            } else {
                that.receivefun(arg)
            }
        },
        receivefun: function(arg) {
            let that = this
            let startDate = that.$moment(arg.event.start).format(`YYYY-MM-DD HH:mm:00`)
            let removeids = [arg.event.id]
            let resources = arg.event.getResources()
            let room = resources && resources[0]
            let newRoomId = room.id
            // 有手术时间
            let costTime = 0
            if (arg.event.extendedProps.cost_time && arg.event.extendedProps.cost_time != 0) {
                costTime = _.round(arg.event.extendedProps.cost_time, 2)
            } else {
                costTime = that.defaultCostTime
            }
            let endDate = that
                .$moment(startDate)
                .add(costTime, that.timeUnit)
                .format(`YYYY-MM-DD HH:mm:00`)
            var events = room.getEvents()
            // 开启时间相交强验证后，判断 当前拖拽的手术时长是否相交
            if (that.operationRoomValidation && that.operationRoomValidation == `1`) {
                try {
                    that.validateMixed(arg.event.id, startDate, endDate, events)
                } catch (e) {
                    if (e.message != `EndIterative`) throw e
                    let calendar = that.$refs.myCalendar.getApi()
                    calendar.refetchResources()
                    calendar.refetchEvents()
                    return
                }
            }

            that.checkSurgery(removeids).then((d) => {
                if (d && d != ``) {
                    this.$confirm(d, `提示`, {
                        confirmButtonText: `确定排程`,
                        cancelButtonText: `取消排程`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            that.docScheduleSurgeries(arg, costTime, startDate, newRoomId, removeids)
                        })
                        .catch(e => {
                            that.$emit(`reloadLeftList`)
                            let calendar = that.$refs.myCalendar.getApi()
                            calendar.refetchResources()
                            calendar.refetchEvents()
                        })
                } else {
                    that.docScheduleSurgeries(arg, costTime, startDate, newRoomId, removeids)
                }
            })
                .catch(e => {
                    that.$emit(`reloadLeftList`)
                    let calendar = that.$refs.myCalendar.getApi()
                    calendar.refetchResources()
                    calendar.refetchEvents()
                })
        },
        checkSurgery(ids) {
            // 存储校验
            return new Promise((resolve, reject) => {
                let that = this // , int[] surgeryIds
                let req = that.myaxios.put(`/api/Preoperative/Schedule/CheckSurgery`, ids)
                req.then(d => {
                    resolve(d)
                }).catch(e => {
                    reject(e)
                })
            })
        },
        docScheduleSurgeries(arg, costTime, startDate, newRoomId, removeids) {
            let that = this
            let req1 = that.myaxios.put(`/api/Preoperative/Schedule/ScheduleSurgeriesByCalendar?date=${startDate}&roomId=${newRoomId}`, removeids)
            req1.then(data => {
                let r = {
                    oldRoomId: newRoomId,
                    newRoomId: newRoomId,
                    planTime: that.$moment(arg.event.start).format(`YYYY-MM-DD HH:mm`),
                    costTime: costTime
                }

                // 获取已排程
                let req = that.myaxios.put(
                    `api/Preoperative/Schedule/ModifySchedulePlanAndCostTime?oldRoomId=${r.oldRoomId}&newRoomId=${r.newRoomId}&planTime=${r.planTime}&costTime=${r.costTime}`,
                    removeids
                )
                req.then(data1 => {
                    // arg.event.remove()
                    that.$emit(`reloadLeftList`)
                    let calendar = that.$refs.myCalendar.getApi()
                    calendar.refetchResources()
                    calendar.refetchEvents()
                    // calendar.render()
                    that.$message.success(`排程成功`)
                })
            }).catch(e => {
                that.$emit(`reloadLeftList`)
                let calendar = that.$refs.myCalendar.getApi()
                calendar.refetchResources()
                calendar.refetchEvents()
            })
        },
        // 判断是否相交
        validateMixed(eventId, start, end, events) {
            let that = this
            events.forEach(event => {
                if (event.id != eventId) {
                    if (event.extendedProps.isOtherEvent) {
                        let otherstartDate = event.extendedProps.start_time
                        let otherendDate = event.extendedProps.end_time
                        if (start < otherendDate && end > otherstartDate) {
                            that.$message.error(`当前时间被占用，请调整时间！`)
                            throw new Error(`EndIterative`)
                        }
                    } else {
                        let otherstartDate = that.$moment(event.start).format(`YYYY-MM-DD HH:mm:00`)
                        let costTime = 0
                        if (event.extendedProps.cost_time && event.extendedProps.cost_time != 0) {
                            costTime = _.round(event.extendedProps.cost_time, 2)
                        } else {
                            costTime = that.defaultCostTime
                        }
                        let otherendDate = that
                            .$moment(otherstartDate)
                            .add(costTime, that.timeUnit)
                            .format(`YYYY-MM-DD HH:mm:00`)
                        if (start < otherendDate && end > otherstartDate) {
                            that.$message.error(`当前排程时间/手术时长与另一个病人${event.extendedProps.patient_name}冲突，请调整时间！`)
                            throw new Error(`EndIterative`)
                        }
                    }
                }
            })
        },
        handleEventClick(info) {
            // 日程区块，单击时触发
            if (info.event.extendedProps.isOtherEvent) {
                return
            }
            var eventObj = info.event
            eventObj.setExtendedProp(`ischecked`, !eventObj.extendedProps.ischecked)
            if (eventObj.extendedProps.ischecked) {
                this.selectedEvents.push(eventObj.extendedProps)
                this.removeLeftSelectData(info.event.id)
            } else {
                _.remove(this.selectedEvents, function(item) {
                    return item.ischecked == true && item.id == eventObj.extendedProps.id
                })
            }
        },
        handleEventDblClick(info) {
            let that = this
            if (info.event.extendedProps.isOtherEvent) {
                return
            }
            that.edit.surgeryId = parseInt(info.event.id)
            that.edit.dialogFormVisible = true
            that.edit.isReadOnly = !that.isHaveCardEdit
            return false
        },
        openaddfrom() {
            let that = this
            that.addfrom.dialogFormVisible = true
            that.addfrom.defaultplanTime = that.$moment(this.rdate).format(`YYYY/MM/DD 08:00:00`)
            return false
        },
        handleOtherEventDblClick(info) {
            let that = this
            var eventObj = info.event
            let row = _.find(that.otherschedule_list, { id: parseInt(eventObj.id) })
            that.editotherschedule(row)
        },
        removeLeftSelectData(eventId) {
            let id = parseInt(eventId)
            this.$emit(`removeLeftSelectData`, id)
        },
        cancelSchedule() {
            let that = this
            let msgs = ``
            let pmise = new Promise((resolve, reject) => {
                let surgeryIds = []
                if (that.leftcheckedRows && that.leftcheckedRows.length > 0) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 20) {
                            surgeryIds.push(d.id)
                            msgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                        }
                    })
                }
                if (that.selectedEvents.length > 0) {
                    that.selectedEvents.map(d => {
                        if (d.enum_surgery_status == 20) {
                            surgeryIds.push(d.id)
                            msgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                        }
                    })
                }

                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择已排程手术!`)
                    return
                }

                if (surgeryIds.length > 0) {
                    msgs = msgs.slice(0, msgs.length - 1)
                    return this.$confirm(`请确认是否取消${msgs}的排程?`, `提示`, {
                        confirmButtonText: `确定`,
                        cancelButtonText: `取消`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            resolve(surgeryIds)
                        })
                        .catch(e => {
                            reject([])
                        })
                } else {
                    that.$message.success(`请选择已排程手术!`)
                }
            })

            pmise
                .then(surgeryIds => {
                    let reqs =
                        surgeryIds &&
                        surgeryIds.map(d => {
                            return this.myaxios.put(`/api/Preoperative/Schedule/CancelSchedule/${d}`)
                        })
                    this.myaxios
                        .all(...reqs)
                        .then(data => {
                            let calendar = that.$refs.myCalendar.getApi()
                            let allEvents = calendar.getEvents()
                            surgeryIds.forEach(sid => {
                                let surgery = _.find(allEvents, { id: sid.toString() })
                                if (surgery) {
                                    surgery.remove()
                                }
                            })
                            that.selectedEvents = []
                            that.refetch()
                            that.$emit(`reloadLeftList`)
                        })
                        .catch(e => {})
                })
                .catch(e => {})
        },
        loadingOverruleView(btnName) {
            let that = this
            let surgeryIds = []
            let rejectApplyMsgs = ``
            if (that.leftcheckedRows && that.leftcheckedRows.length > 0) {
                if (btnName == `rejectApply`) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 10 || d.enum_surgery_status == 20) {
                            surgeryIds.push(d.id)
                            rejectApplyMsgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                        }
                    })
                } else if (btnName == `rejectApprove`) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 10) {
                            surgeryIds.push(d.id)
                            rejectApplyMsgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                        }
                    })
                } else {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 20) {
                            surgeryIds.push(d.id)
                            rejectApplyMsgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                        }
                    })
                }
            }

            if (btnName == `rejectApply` || btnName == `cancelSurgery`) {
                that.selectedEvents.map(d => {
                    if (d.enum_surgery_status == 20) {
                        surgeryIds.push(d.id)
                        rejectApplyMsgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                    }
                })
            }
            let msg = btnName == `cancelSurgery` ? `取消` : `驳回`
            if (surgeryIds.length == 0) {
                if (btnName == `rejectApprove`) {
                    this.$message.warning(`请选择待排程的手术!`)
                }
                if (btnName == `rejectApply`) {
                    this.$message.warning(`请选择待排程或已排程的手术!`)
                }
                if (btnName == `cancelSurgery`) {
                    this.$message.warning(`请选择已排程的手术!`)
                }
                return
            }
            // 增加驳回前提示
            rejectApplyMsgs = rejectApplyMsgs.slice(0, rejectApplyMsgs.length - 1)
            if (btnName == `rejectApply`) {
                rejectApplyMsgs += `的手术申请`
            } else if (btnName == `rejectApprove`) {
                rejectApplyMsgs += `的手术审核`
            } else {
                rejectApplyMsgs += `的已排程手术`
            }

            this.$confirm(`提示`, {
                title: `提示`,
                message: this.$createElement(`div`, [this.$createElement(`p`, `此操作将${msg}{${rejectApplyMsgs}`), this.$createElement(`p`, `是否继续?`)]),
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`
            })
                .then(() => {
                    var col = _.find(this.overrule.columns, c => c.prop == `reject_reason`)
                    if (col) {
                        if (this.rejectReasons && this.rejectReasons.length > 0) {
                            col.options = this.rejectReasons
                            col.type = `select`
                        } else {
                            col.options = []
                            col.type = `string`
                        }
                    }
                    if (btnName == `cancelSurgery`) {
                        this.overrule.title = `取消手术`
                        col.label = `取消原因`
                    }
                    this.overrule.emitBtnName = btnName
                    this.overrule.dialogFormVisible = true
                })
                .catch(e => {
                    console.log(e)
                })
        },
        loadRejectResons() {
            return new Promise(resolve => {
                let req = this.myaxios.getNoloading(`/api/AcisSystem/Config/GetByKey?key=ApplyRejectResons`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.rejectReasons = data.value
                            .trim()
                            .split(`,`)
                            .map(x => {
                                return {
                                    label: x,
                                    value: x
                                }
                            })
                    } else {
                        this.rejectReasons = []
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadPrintSurgeryConfig() {
            return new Promise(resolve => {
                let req = this.myaxios.getNoloading(`/api/AcisSystem/Config/GetByKey?key=PrintSurgeryConfig`)
                req.then(data => {
                    if (data && data.value && data.value.trim()) {
                        this.printSurgeryConfigs = JSON.parse(data.value)
                    } else {
                        this.printSurgeryConfigs = []
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        loadCheckList(room) {
            this.active_item.room_setting = room.room_setting
            this.active_item.date = this.$moment(room.room_setting.date).format(`YYYY-MM-DD`)
            this.active_item.check_date = room.room_setting.check_date
            this.active_item.dic_operating_room_id = room.id
            this.active_item.check_user_id = room.room_setting.check_user_id
            this.dialogFormVisible1 = true
            this.$nextTick(() => {
                this.$refs.doc && this.$refs.doc.loadDocument()
            })
        },
        afterDocSaved() {
            let req = this.myaxios.put(`/api/Preoperative/RoomSetting/Put`, {
                id: this.active_item.room_setting.id,
                date: this.active_item.room_setting.date,
                dic_operating_room_id: this.active_item.dic_operating_room_id,
                check_user_id: this.active_item.check_user_id,
                check_date: this.active_item.check_date,
                check_result: this.btn_chk_result
            })

            req.then(data => {
                this.refetch()
                this.dialogFormVisible1 = false
            }).catch(e => {
                console.log(e)
            })
        },
        SaveChanges(result) {
            let valid = true
            this.btn_chk_result = result
            if (valid) {
                this.$refs.doc.save()
            }
        },
        saveOverrule(row) {
            let that = this
            let msg = that.overrule.emitBtnName == `cancelSurgery` ? `取消` : `驳回`
            let surgeryIds = []
            if (that.leftcheckedRows && that.leftcheckedRows.length > 0) {
                if (that.overrule.emitBtnName == `rejectApply`) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 10 || d.enum_surgery_status == 20) {
                            surgeryIds.push(d.id)
                        }
                    })
                } else if (that.overrule.emitBtnName == `rejectApprove`) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 10) {
                            surgeryIds.push(d.id)
                        }
                    })
                } else {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 20) {
                            surgeryIds.push(d.id)
                        }
                    })
                }
            }

            if (that.overrule.emitBtnName == `rejectApply` || that.overrule.emitBtnName == `cancelSurgery`) {
                that.selectedEvents.map(d => {
                    if (d.enum_surgery_status == 20) {
                        surgeryIds.push(d.id)
                    }
                })
            }

            if (surgeryIds.length == 0) {
                if (that.overrule.emitBtnName == `rejectApprove`) {
                    this.$message.warning(`请选择待排程的手术!`)
                }
                if (that.overrule.emitBtnName == `rejectApply`) {
                    this.$message.warning(`请选择待排程或已排程的手术!`)
                }
                if (that.overrule.emitBtnName == `cancelSurgery`) {
                    this.$message.warning(`请选择已排程的手术!`)
                }

                return
            }

            try {
                surgeryIds.map(d => {
                    let requestData = {
                        id: d,
                        visit_info: null,
                        reject_reason: row.reject_reason
                    }
                    if (that.overrule.emitBtnName == `rejectApply`) {
                        let req = this.myaxios.put(`/api/Preoperative/Apply/Reject`, requestData)
                        req.then(data => {
                            that.$emit(`reloadLeftList`)
                            that.refetch()
                            // 调用手术回写
                            let pushModel = {
                                surgeryId: d,
                                surgeryInfoSendType: 1
                            }
                            var reps = this.myaxios.post(`/api/Preoperative/Apply/SurgeryInfoPush`, pushModel)
                            reps.then(data => {})
                        })
                    }
                    if (that.overrule.emitBtnName == `rejectApprove`) {
                        let req = this.myaxios.put(`/api/Preoperative/Apply/RejectApprove`, requestData)
                        req.then(data => {
                            that.$emit(`reloadLeftList`)
                            that.refetch()
                        })
                    }
                    if (that.overrule.emitBtnName == `cancelSurgery`) {
                        let req = this.myaxios.put(`/api/Preoperative/Schedule/CancelSurgery?surgeryId=${requestData.id}&&reason=${requestData.reject_reason}`)
                        req.then(data => {
                            that.$emit(`reloadLeftList`)
                            that.refetch()
                        })
                    }
                })
                that.$message.success(`手术${msg}成功`)
                that.overrule.dialogFormVisible = false
            } catch (e) {
                that.$message.error(`手术${msg}失败`)
            }
        },
        getDraggleAttrs(id) {
            return {
                attrs: {
                    id: id
                }
            }
        },
        exchangeRoom($event) {
            let that = this
            let from = $event.from
            from.innerHTML = `<span id="${from.id}" class="operationRoom" style="">${from.innerText}</span>`
            let oldRoomId = from.id
            let to = $event.to
            let newRoomId = to.id
            let room = _.find(that.operationRoom, { value: parseInt(to.id) })
            let toName = (room && room.label) || ``
            to.innerHTML = `<span id="${to.id}" class="operationRoom" style="">${toName}</span>`
            let currentDate = that.getCurrentDate()
            let date = that.$moment(currentDate).format(`YYYY-MM-DD`)

            that.$confirm(`确认将 ${from.innerText} 与 ${to.innerText} 当日排程进行交换?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            })
                .then(() => {
                    let req = that.myaxios.put(`/api/Preoperative/Schedule/ExchangeRoom?roomA=${oldRoomId}&roomB=${newRoomId}&date=${date}`)
                    req.then(data => {
                        let calendar = that.$refs.myCalendar.getApi()
                        calendar.refetchResources()
                        calendar.refetchEvents()
                        that.$message.success(`交换成功`)
                    }).catch(e => {
                        that.$message.error(`交换失败`)
                    })
                })
                .catch(e => {})
        },
        changeCheck(row) {
            let that = this
            let rersourceId = row.resource.id
            let ischecked = !row.resource.extendedProps.ischecked
            row.resource.setExtendedProp(`ischecked`, ischecked)
            let calendar = that.$refs.myCalendar.getApi()
            var resource = calendar.getResourceById(rersourceId)
            var events = resource && resource.getEvents()
            events.forEach(event => {
                if (!event.extendedProps.isOtherEvent) {
                    event.setExtendedProp(`ischecked`, ischecked)
                    this.handleSelectedEvents(ischecked, event)
                }
            })
        },
        handleSelectedEvents(ischecked, event) {
            let that = this
            let isexist = _.findIndex(that.selectedEvents, function(t) {
                return t.id == event.id
            })
            if (ischecked) {
                if (isexist <= -1) {
                    this.selectedEvents.push(event.extendedProps)
                    that.removeLeftSelectData(event.id)
                }
            } else {
                if (isexist > -1) {
                    that.selectedEvents.splice(isexist, 1)
                }
            }
        },
        roomDragOption(isopen) {
            return {
                animation: 0,
                group: { name: `room`, put: [`listview`, `fixed-listview`], pull: false },
                disabled: false,
                ghostClass: `ghost`,
                sort: false
            }
        },
        loadScheduleHelper(command) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            let schedulingDate = that.$moment(calendar.getDate()).format(`YYYY-MM-DD`)
            let req
            if (command == `section`) {
                req = that.myaxios.getNoloading(`/api/Preoperative/Schedule/GetAutoScheduleBySection`, { date: schedulingDate })
                that.scheduling_way = 1
            }
            if (command == `worker`) {
                req = that.myaxios.getNoloading(`/api/Preoperative/Schedule/GetAutoScheduleBySurgeon`, { date: schedulingDate })
                that.scheduling_way = 2
            }
            if (command == `surgery`) {
                req = that.myaxios.getNoloading(`/api/Preoperative/Schedule/GetAutoScheduleBySurgery`, { date: schedulingDate })
                that.scheduling_way = 3
            }
            if (command == `autoOneKeySchedule`) {
                that.$confirm(`一键排程将对所有待排程的手术根据自定义规则进行排程,是否继续`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                })
                    .then(() => {
                        that.scheduling_way = 4
                        that.myaxios.getNoloading(`/api/Preoperative/Schedule/GetOneKeyAutoSchedule`).then(data => {
                            that.refetch()
                            that.$emit(`reloadLeftList`)
                            if (data) {
                                that.$message.success(data)
                            } else {
                                that.$message.success(`一键排程成功`)
                            }
                        }).catch(e => { })
                    })
                    .catch(e => { })
                return
            }
            if (command == `changeRoom`) {
                let surgerys = []
                if (that.leftcheckedRows && that.leftcheckedRows.length > 0) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 20) {
                            surgerys.push(d)
                        }
                    })
                } else {
                    that.selectedEvents.map(d => {
                        if (d.enum_surgery_status == 20) {
                            surgerys.push(d)
                        }
                    })
                }
                if (surgerys.length == 0) {
                    this.$message.warning(`请选择已排程手术`)
                    return
                }
                this.showChangeRoom(surgerys)
                return
            }
            if (command == `setAnesDoctor`) {
                let surgeryIds = []
                if (that.leftcheckedRows && that.leftcheckedRows.length > 0) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 10) {
                            surgeryIds.push(d.id)
                        }
                    })
                }
                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择新申请手术`)
                    return
                }
                that.showSetAnesDoctor(surgeryIds)
                return
            }
            if (command == `clearWorkers`) {
                let surgeryIds = []
                if (that.leftcheckedRows && that.leftcheckedRows.length > 0) {
                    that.leftcheckedRows.map(d => {
                        if (d.enum_surgery_status == 10 || d.enum_surgery_status == 20) {
                            surgeryIds.push(d.id)
                        }
                    })
                } else {
                    that.selectedEvents.map(d => {
                        if (d.enum_surgery_status == 10 || d.enum_surgery_status == 20) {
                            surgeryIds.push(d.id)
                        }
                    })
                }
                if (surgeryIds.length == 0) {
                    this.$message.warning(`请选择新申请或已排程手术`)
                    return
                }
                that.showClearWorkersForm(surgeryIds)
                return
            }

            req.then(data => {
                that.autoScheduleSurgeries = _.filter(data, { dic_operating_ward_id: parseInt(that.dic_operating_ward_id) })
                // 深拷贝一个autoScheduleColumnList
                that.autoScheduleColumnListBand = _.cloneDeep(that.autoScheduleColumnList)
                if (that.scheduling_way == 2) {
                    let e = that.autoScheduleColumnListBand.filter(p => {
                        return p.prop == `surgeon`
                    })
                    that.autoScheduleColumnListBand.splice(that.autoScheduleColumnListBand.indexOf(e[0]), 1)
                    that.autoScheduleColumnListBand.splice(1, 0, e[0])
                } else if (that.scheduling_way == 3) {
                    let e = that.autoScheduleColumnListBand.filter(p => {
                        return p.prop == `surgeries`
                    })
                    that.autoScheduleColumnListBand.splice(that.autoScheduleColumnListBand.indexOf(e[0]), 1)
                    that.autoScheduleColumnListBand.splice(1, 0, e[0])
                }

                // that.autoScheduleSurgeries = data
            }).catch(e => {
                that.autoScheduleSurgeries = []
            })
            that.autoScheduleVisible = true
        },
        syncSchedule(command) {
            let that = this
            if (command == `syncScheduleSurgery`) {
                that.syncScheduleSurgery()
            }
            if (command == `pushSchedule`) {
                that.pushSchedule()
            }
            if (command == `pushHySchedule`) {
                that.pushHySchedule()
            }
        },
        cancel(command) {
            let that = this
            if (command == `cancelSchedule`) {
                that.cancelSchedule()
            }
            if (command == `cancelSurgery`) {
                that.loadingOverruleView(command)
            }
            if (command == `rejectApprove`) {
                that.loadingOverruleView(command)
            }
            if (command == `rejectApply`) {
                that.loadingOverruleView(command)
            }
        },
        // 同步急诊手术信息
        syncScheduleSurgery() {
            let that = this
            let req = this.myaxios.post(`/api/Anonymous/Carte/RunCarteServer?type=carte_emergency_surgeryInfo&paramStr=1`)
            req.then(data => {
                let calendar = this.$refs.myCalendar.getApi()
                calendar.refetchResources()
                calendar.refetchEvents()
                that.$emit(`reloadLeftList`)
            }).catch(e => {
                console.log(e)
            })
        },
        // 排程回传
        pushSchedule() {
            let pushRows = []
            let that = this
            if (that.leftcheckedRows.length > 0 || that.selectedEvents.length > 0) {
                pushRows = that.leftcheckedRows.concat(that.selectedEvents)
            } else {
                // 若未勾选则回传全部已排手术
                pushRows = that.scheduled_list
            }
            if (pushRows.length > 0) {
                let reqs = pushRows.map(d => {
                    let postdata = {
                        surgeryId: d.id,
                        surgeryInfoSendType: 2
                    }
                    return that.myaxios.post(`/api/Preoperative/Apply/SurgeryInfoPush`, postdata)
                })
                that.myaxios.all(...reqs).then(() => {
                    let calendar = that.$refs.myCalendar.getApi()
                    calendar.refetchResources()
                    calendar.refetchEvents()
                    that.$emit(`reloadLeftList`)
                    that.$message.success(`排程回传完成`)
                })
            } else {
                that.$message.warning(`请先选择要回传的记录！`)
            }
        },
        // 排程回传和祐
        pushHySchedule() {
            let that = this
            return that.myaxios.post(`/api/Preoperative/Apply/SurgeryInfoPushHY`).then(() => {
                let calendar = that.$refs.myCalendar.getApi()
                calendar.refetchResources()
                calendar.refetchEvents()
                that.$emit(`reloadLeftList`)
                that.$message.success(`排程回传完成`)
            })
        },
        ExtraButtonClick(target) {
            let e = {}
            ;({ index: e.index, row: e.row } = target)
            if (this[target.emit]) {
                this[target.emit](e)
            } else {
                this.$emit(target.emit, e)
            }
        },
        cancelAutoSchedule({ row, index }) {
            this.autoScheduleSurgeries.splice(index, 1)
        },
        confirmAutoSchedule() {
            let that = this
            if (that.autoScheduleSurgeries.length == 0) {
                this.autoScheduleVisible = false
                return
            }
            let calendar = that.$refs.myCalendar.getApi()
            let schedulingDate = that.$moment(calendar.getDate()).format(`YYYY-MM-DD`)
            let reqs = []
            let cms = _.groupBy(that.autoScheduleSurgeries, `dic_operating_room_id`)
            _.forEach(cms, function(value, roomId) {
                let req = that.myaxios.put(
                    `/api/Preoperative/Schedule/ScheduleSurgeriesByCalendar?date=${schedulingDate}&roomId=${roomId}`,
                    value.map(v => v.id)
                )
                reqs.push(req)
            })

            that.myaxios
                .all(...reqs)
                .then(datas => {
                    that.$message.success(`保存成功`)
                    calendar.refetchResources()
                    calendar.refetchEvents()
                    calendar.render()
                    this.autoScheduleVisible = false
                })
                .catch(e => {
                    console.log(e)
                    that.$message.error(`保存失败`)
                })
        },
        printSurenry(command) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            let schedulingDate = that.$moment(calendar.getDate()).format(`YYYY-MM-DD`)
            let from = schedulingDate
            let to = this.$moment(calendar.getDate())
                .add(1, `days`)
                .format(`YYYY-MM-DD`)
            if (command == `ExportExcel`) {
                this.myaxios.getNoloading(`/api/Preoperative/Schedule/GetScheduleForExport`, { wardId: this.dic_operating_ward_id, from: from, to: to }).then(data => {
                    if (data.length <= 0) {
                        this.$message.warning(`暂无导出数据`)
                        return
                    }
                    // 是否需要按状态过滤
                    let filterdata = this.isEnableFilterStatusForExportExcel && this.isEnableFilterStatusForExportExcel == `1`
                    if (filterdata) {
                        this.exportExcel.exportDatas = data
                        this.exportExcel.dialogFormVisible = true
                    } else {
                        this.myaxios.export_excel(data, `手术排程.xls`)
                    }
                })
                return
            }
            if (command && command.code && command.type) {
                if (command.type == 2 || command.type == 3 || command.type == 4 || command.type == 5) {
                    // 日期阶段打印
                    this.printSurenryForm.code = command.code
                    this.printSurenryForm.dialogFormVisible = true
                    this.printSurenryForm.from_to = [this.$moment(this.scheduling_date).format(`YYYY/MM/DD 00:00:00`), this.$moment(this.scheduling_date).format(`YYYY/MM/DD 23:59:59`)]
                    if (command.type == 5) {
                        // 默认设置成今天
                        this.printSurenryForm.from_to = [this.$moment().format(`YYYY/MM/DD 00:00:00`), this.$moment().format(`YYYY/MM/DD 23:59:59`)]
                    }
                    this.printSurenryForm.roomids = []
                    this.printSurenryForm.wardids = []
                    this.printSurenryForm.type = command.type
                    if (command.extradata != null && command.extradata != ``) {
                        this.printSurenryForm.extradata = command.extradata
                    }
                    let r = _.filter(this[`operation_ward_auth`], { value: parseInt(this.dic_operating_ward_id) })
                    console.log(`手术间`)
                    this.printSurenryForm.rooms = (r && r[0] && r[0].operation_room) || []
                } else {
                    let req2 = this.myaxios.getNoloading(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                    req2.then(isShow => {
                        // 批量打印手术通知单
                        if (command.type == 1) {
                            let surgeryIds = []
                            // 获取左侧勾选的数据列表
                            if (that.leftcheckedRows && that.leftcheckedRows.length > 0) {
                                that.leftcheckedRows.map(d => {
                                    surgeryIds.push(d.id)
                                })
                            }
                            // 获取右侧勾选的数据列表
                            if (that.selectedEvents.length > 0) {
                                that.selectedEvents.map(d => {
                                    surgeryIds.push(d.id)
                                })
                            }
                            if (surgeryIds.length) {
                                this.$store.dispatch(`PRINT_PDF`, {
                                    host: this.$root.DOCSERVICE_BASE,
                                    params: Object.assign(
                                        {
                                            docid: this.$root.DOCUMENT[command.code],
                                            id1: `99999`,
                                            objId: surgeryIds.map(d => d).toString()
                                        },
                                        { isShowSendPrintMessage: isShow.value }
                                    )
                                })
                            } else {
                                this.$message.warning(`请选择需要打印的手术通知`)
                            }
                            return
                        }

                        this.$store.dispatch(`PRINT_PDF`, {
                            host: this.$root.DOCSERVICE_BASE,
                            params: Object.assign(
                                {
                                    docid: this.$root.DOCUMENT[command.code],
                                    id1: ``,
                                    objId: `${this.dic_operating_ward_id}|${this.$moment(calendar.getDate()).format(`YYYY/MM/DD 00:00:00`)}`,
                                    from: this.$moment(calendar.getDate()).format(`YYYYMMDDHHmm`),
                                    to: this.$moment(calendar.getDate())
                                        .add(1, `days`)
                                        .format(`YYYYMMDDHHmm`)
                                },
                                { isShowSendPrintMessage: isShow.value }
                            )
                        })
                    }).catch(e => {
                        console.log(e)
                    })
                }
            }
        },
        printSurenryByTime() {
            console.log(this.printSurenryForm)

            this.printSurenryForm.dialogFormVisible = false
            if (this.printSurenryForm.type == 2 && this.printSurenryForm.extradata && this.printSurenryForm.extradata.ExportUrl != ``) {
                // 自定义execl打印
                this.myaxios
                    .get(`/api/Preoperative/Schedule/GetScheduleExtradata`, {
                        wardId: this.dic_operating_ward_id,
                        from: this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`),
                        to: this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`),
                        objs: ``
                    })
                    .then(data => {
                        if (data.length <= 0) {
                            this.$message.warning(`暂无导出数据`)
                            return
                        }
                        this.myaxios.export_excel_Extradata(
                            this.printSurenryForm.extradata.ExportUrl,
                            data,
                            `手术排程.xls`,
                            `手术安排表(${this.$moment(this.printSurenryForm.from_to[0]).format(`MM.DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`MM.DD`)})`
                        )
                        // // 是否需要按状态过滤
                        // let filterdata = this.isEnableFilterStatusForExportExcel && this.isEnableFilterStatusForExportExcel == `1`
                        // if (filterdata) {
                        //     this.exportExcel.exportDatas = data
                        //     this.exportExcel.dialogFormVisible = true
                        // } else {
                        //     this.myaxios.export_excel(data, `手术排程.xls`)
                        // }
                    })
            } else if (this.printSurenryForm.type == 3 && this.printSurenryForm.extradata && this.printSurenryForm.extradata.ExportUrl != ``) {
                // roomids: this.printSurenryForm.roomids,
                let wardId = this.dic_operating_ward_id
                let from = this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`)
                let to = this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`)
                let roomids = this.printSurenryForm.roomids && this.printSurenryForm.roomids.join(`,`)
                this.myaxios
                    .export_excel_Template(this.printSurenryForm.extradata.ExportUrl + `?wardId=${wardId}&roomids=${roomids}&from=${from}&to=${to}`, null, `手术排程.xls`,
                        `手术安排表(${this.$moment(this.printSurenryForm.from_to[0]).format(`MM.DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`MM.DD`)})`)
                    .then(data => {
                        // if (data.length <= 0) {
                        //     this.$message.warning(`暂无导出数据`)
                        // }
                        // this.myaxios.export_excel_Extradata(
                        //     this.printSurenryForm.extradata.ExportUrl,
                        //     data,
                        //     `手术排程.xls`,
                        //     `手术安排表(${this.$moment(this.printSurenryForm.from_to[0]).format(`MM.DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`MM.DD`)})`
                        // )
                        // // 是否需要按状态过滤
                        // let filterdata = this.isEnableFilterStatusForExportExcel && this.isEnableFilterStatusForExportExcel == `1`
                        // if (filterdata) {
                        //     this.exportExcel.exportDatas = data
                        //     this.exportExcel.dialogFormVisible = true
                        // } else {
                        //     this.myaxios.export_excel(data, `手术排程.xls`)
                        // }
                    })
            } else if (this.printSurenryForm.type == 4 && this.printSurenryForm.extradata && this.printSurenryForm.extradata.ExportUrl != ``) {
                let from = this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`)
                let to = this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`)
                let wardids = this.printSurenryForm.wardids && this.printSurenryForm.wardids.join(`,`)
                this.myaxios
                    .export_excel_Template(this.printSurenryForm.extradata.ExportUrl + `?wardids=${wardids}&from=${from}&to=${to}`, null, `手术排程.xls`,
                        `手术安排表(${this.$moment(this.printSurenryForm.from_to[0]).format(`MM.DD`)}-${this.$moment(this.printSurenryForm.from_to[1]).format(`MM.DD`)})`)
            } else {
                let from = this.$moment(this.printSurenryForm.from_to[0]).format(`YYYY/MM/DD`)
                let to = this.$moment(this.printSurenryForm.from_to[1]).format(`YYYY/MM/DD`)
                let wardids = this.printSurenryForm.wardids && this.printSurenryForm.wardids.join(`,`)
                let objIdstr = `${this.dic_operating_ward_id}|${from}-${to}`
                if (this.printSurenryForm.type == 4) {
                    objIdstr = `${wardids}|${from}-${to}`
                }
                console.log(`objId`, objIdstr)
                let req2 = this.myaxios.getNoloading(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
                req2.then(isShow => {
                    this.$store.dispatch(`PRINT_PDF`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: this.$root.DOCUMENT[this.printSurenryForm.code],
                                id1: ``,
                                objId: objIdstr,
                                from: this.$moment(this.printSurenryForm.from_to[0]).format(`YYYYMMDDHHmm`),
                                to: this.$moment(this.printSurenryForm.from_to[1]).format(`YYYYMMDDHHmm`)
                            },
                            { isShowSendPrintMessage: isShow.value }
                        )
                    })
                }).catch(e => {
                    console.log(e)
                })
            }
        },
        setup(command) {
            let that = this
            if (command == `showcardSetting`) {
                that.showcardSetting()
                return
            }

            if (command == `timelinesetup`) {
                that.timelinesetup()
            }
        },
        refetch() {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            calendar.refetchResources()
            calendar.refetchEvents()
            let bedcardview = that.$refs.bedcardview
            if (bedcardview) {
                let first = this.$moment(this.rdate).format(`YYYY-MM-DD`)
                this.getOperationRooms(first)
                    .then(data => {
                        this.rooms = data
                    })
                    .catch(e => {
                        console.log(e)
                    })
                bedcardview.refresh()
                that.$emit(`reloadLeftList`)
            }
        },
        ScheduleSurgeries(schedulingDate, roomId, surgeryIds) {
            let that = this

            that.checkSurgery(surgeryIds).then((d) => {
                if (d && d != ``) {
                    this.$confirm(d, `提示`, {
                        confirmButtonText: `确定排程`,
                        cancelButtonText: `取消排程`,
                        type: `warning`,
                        closeOnClickModal: false
                    })
                        .then(() => {
                            that.dorScheduleSurgeries(schedulingDate, roomId, surgeryIds)
                        })
                        .catch(e => {
                            that.refetch()
                        })
                } else {
                    that.dorScheduleSurgeries(schedulingDate, roomId, surgeryIds)
                }
            })
        },
        dorScheduleSurgeries(schedulingDate, roomId, surgeryIds) {
            let that = this
            let req = that.myaxios.put(`/api/Preoperative/Schedule/ScheduleSurgeriesByTimeLines?date=${schedulingDate}&roomId=${roomId}`, surgeryIds)
            req.then(data => {
                that.refetch()
                that.$emit(`reloadLeftList`)
                that.$message.success(`保存成功`)
            })
        },
        afterSave(surgeryId, surgeryStatus, operatingRoomId) {
            let that = this
            that.refetch()
            that.$emit(`reloadLeftList`)
            that.$message.success(`保存成功`)
        },
        afteradd(aftersaveid) {
            let that = this
            that.$emit(`reloadLeftList`)
            let calendar = that.$refs.myCalendar.getApi()
            calendar.refetchResources()
            calendar.refetchEvents()
            that.$message.success(`保存成功`)
        },
        loadSettingForm(id, title, room) {
            let that = this
            let calendar = that.$refs.myCalendar.getApi()
            let schedulingDate = that.$moment(calendar.getDate()).format(`YYYY-MM-DD`)
            this.$emit(`showRoomSetting`, id, title, room, schedulingDate)
        },
        loadAllMenus() {
            // 获取菜单
            return this.myaxios.getNoloading(`/api/AcisSystem/Menu/Get`)
        },
        windowOpen(event, menuInfo) {
            let that = this
            let date = that.$moment(event.start).format(`YYYY/MM/DD`)
            this.openUrl(menuInfo, event, date)
        },
        openUrl(menuInfo, event, date) {
            console.log(menuInfo)
            let url = (menuInfo && menuInfo.url) || `/`
            // 第三方链接直接弹框打开，不用二次弹框打开
            if (url.indexOf(`source=`) > -1) {
                url = decodeURIComponent(url.split(`source=`)[1])
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${event.id}&rdate=${date}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
                this.windowOpenUrl(event.id, url)
            } else {
                // 本系统页面链接，直接调用患者管理路由加载界面
                url += url.indexOf(`?`) > -1 ? `&` : `?`
                url = `${url}surgery_id=${event.id}&rdate=${date}&isOnlyShowMain=true&workbar=${menuInfo.workbar}&record_type=1`
                let routeUrl = this.$router.resolve({
                    path: url
                })
                var w = this.screenWidth - 10
                var h = this.screenHeight - 10
                if (typeof winformMsg != `undefined`) {
                    w = w + 500
                    h = h + 400
                }
                window.open(routeUrl.href, ``, `width=${w},height=${h},top=10,left=10`)
            }
        },
        triggerCollapse() {
            if (this.collapse == 0) {
                this.collapse = 1
            } else {
                this.collapse = 0
            }
            this.$emit(`triggerCollapse`, this.collapse)
        },
        showcardSetting() {
            this.cardSettingInfo.dialogFormVisible = true
            this.LoadUserColumns()
        },
        // 加载 日历配置 日历图配置，此设置包括：显示纵轴还是横轴模式，默认间隔等
        LoadTimeLineSetupData() {
            let that = this
            return new Promise(resolve => {
                let req = this.myaxios.getNoloading(`/api/AcisSystem/FullCalendarTimeLineSetup/Get`)
                req.then(data => {
                    that.timeLineSetupInfo = data
                    that.interval = data.interval
                    that.gettimeLineSetupInfo(that.timeLineSetupInfo)
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        LoadUserColumns() {
            let that = this
            let req = this.myaxios.getNoloading(`/api/AcisSystem/SystemServer/GetColumnConfig`, {
                tableName: this.tableName
            })
            req.then(data => {
                let lcs = _.orderBy(that.listColumn, function(lc) {
                    return _.findIndex(data, { col_name: lc.prop })
                })
                that.configColumns = lcs.map(c => {
                    return { value: c.prop, label: c.label, ordernum: c.display_order }
                })
                that.configShowColumns = lcs.map(c => {
                    let obj = _.filter(data, { col_name: c.prop })
                    return { value: c.prop, label: c.label, ordernum: obj[0] == null ? 0 : obj[0].show_order }
                })

                that.user_config_columns = (data && _.filter(data, { enabled: true }).map(d => d.col_name)) || []
                that.user_config_showcolumns = (data && _.filter(data, { show_hit: true }).map(d => d.col_name)) || []
                that.user_config_showcolumns = _.orderBy(that.user_config_showcolumns, `show_order`)
                that.configShowColumns = _.orderBy(that.configShowColumns, `ordernum`)

                if (this.cardSettingInfo.dialogFormVisible == true) {
                    this.configColumnDrop()
                    this.configColumnDropr()
                }
            })
        },
        // 日历卡片上显示自定义链接
        LoadCustomMenuNames() {
            let that = this
            let customMenus = []
            let docMenus = []
            if (this.$root.CalendarCustomLinkMenus && this.$root.CalendarCustomLinkMenus.trim()) {
                customMenus = this.$root.CalendarCustomLinkMenus.trim().split(`,`)
                let menuName = `document2` // 患者文书
                let document2 = _.find(this.business, t => {
                    return (t.business_level == `M004` || t.business_level == `M003`) && t.location == menuName
                })
                if (!document2) {
                    this.$message.error(`患者工作栏 没有配置 患者文书 页面,请配置菜单和工作栏`)
                } else {
                    customMenus.forEach(menu => {
                        if (menu.startsWith(`docId=`)) {
                            let menuarr = menu.split(`|`)
                            if (menuarr && menuarr.length >= 2) {
                                let document2MenuInfo = _.cloneDeep(document2)
                                let rurl = document2MenuInfo.url
                                let menuUrl = menuarr[0]
                                let menuTitle = menuarr[1]
                                rurl += rurl.indexOf(`?`) > -1 ? `&${menuUrl}` : `?${menuUrl}`
                                rurl = `${rurl}&isOnly=1`
                                document2MenuInfo.url = rurl
                                document2MenuInfo.name = menuTitle
                                document2MenuInfo.icon = `fas:file-medical-alt`
                                docMenus.push(document2MenuInfo)
                            }
                        }
                    })
                }
            }

            let menus = _.filter(this.business, c => {
                return _.includes(customMenus, c.name) && (c.business_level == `M003` || c.business_level == `M004`)
            })
            // 多个患者工作栏时去重
            let uncusMenus = _.unionBy(menus, `name`)
            that.customMenuNames = uncusMenus.concat(docMenus)
        },
        SaveUserColumns() {
            let that = this
            let neworder = this.configShowColumns.map((c, index) => {
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    show_order: index,
                    show_hit: _.includes(this.user_config_showcolumns, c.value),
                    table_name: this.tableName
                }
            })

            let uc = this.configColumns.map((c, index) => {
                let obj = _.filter(neworder, { col_name: c.value })
                return {
                    col_name: c.value,
                    display_order: index,
                    enabled: _.includes(this.user_config_columns, c.value),
                    show_order: obj[0].show_order,
                    show_hit: _.includes(this.user_config_showcolumns, c.value),
                    table_name: this.tableName
                }
            })

            let req = this.myaxios.post(`/api/AcisSystem/SystemServer/SetColumnConfig`, uc)
            req.then(data => {
                this.$message.success(`保存成功`)
                let calendar = that.$refs.myCalendar.getApi()
                calendar.refetchEvents()
                this.cardSettingInfo.dialogFormVisible = false
            }).catch(e => {})
        },
        configColumnDrop() {
            const tbody = document.querySelector(`.config-column .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columns`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configColumns.splice(oldIndex, 1)[0]
                    _this.configColumns.splice(newIndex, 0, currRow)
                }
            })
        },
        configColumnDropr() {
            const tbody = document.querySelector(`.config-columna .el-checkbox-group`)
            const _this = this
            Sortable.create(tbody, {
                group: { name: `config-columnas`, push: false, put: false },
                animation: 180,
                fallbackOnBody: true,
                delay: 0,
                onUpdate({ newIndex, oldIndex }) {
                    // 交换排序
                    if (newIndex == oldIndex) return
                    // console.log({ newIndex, oldIndex })
                    const currRow = _this.configShowColumns.splice(oldIndex, 1)[0]
                    _this.configShowColumns.splice(newIndex, 0, currRow)
                    //   this.configShowColumns = _this.configShowColumns
                }
            })
        },
        showSlotLabel(text) {
            let strs = text.split(`:`)
            if (strs.length > 0) {
                if (strs[0].length == 1) {
                    text = `0` + text
                }
                if (strs[0] == `24`) {
                    text = `00` + `:` + strs[1]
                }
            }
            return text
        },
        exportExcelSave(row) {
            let data = this.exportExcel.exportDatas
            if (row.status.length > 0 && data.length > 0) {
                let filterExportData = !_.has(data[0], `状态`)
                    ? data
                    : _.filter(data, c => {
                        return _.includes(row.status, c[`状态`])
                    })
                if (filterExportData.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                this.myaxios.export_excel(filterExportData, `手术排程.xls`).then(data => {
                    this.exportExcel.dialogFormVisible = false
                    this.exportExcel.exportDatas = []
                })
            }
        },
        isjson(jsonstr) {
            if (typeof jsonstr == `string`) {
                try {
                    var obj = JSON.parse(jsonstr)
                    if (typeof obj == `object` && obj) {
                        return true
                    } else {
                        return false
                    }
                } catch (e) {
                    return false
                }
            }
            return false
        },
        windowOpenUrl(surgeryId, refUrl) {
            if (!surgeryId) {
                this.surgeryInfo = {}
                this.visitInfo = {}
                this.hospitalward = {}
                return
            }
            var that = this
            this.myaxios
                .get(`/api/Preoperative/Apply/Get/${surgeryId}`)
                .then(data => {
                    let extrDatas = _.reduce(
                        data.extra_datas,
                        function(result, value, index) {
                            let flag = that.isjson(value.DataValue)
                            if (value.DataValue != `` && flag == true) {
                                result[value.DataKey] = value.DataExtraValue
                            } else {
                                result[value.DataKey] = value.DataValue
                            }
                            return result
                        },
                        {}
                    )
                    this.surgeryInfo = Object.assign(data, extrDatas)
                    this.visitInfo = data.visit_info
                    this.hospitalward = data.hospital_ward
                })
                .then(data => {
                    refUrl = this.setRefurl(refUrl)
                })
                .then(data => {
                    // ACIS-23927手麻系统集成360全息视图
                    if (refUrl.slice(0, 4) != `http` && refUrl.indexOf(`carte_`) != -1) {
                        let type = refUrl.split(`?`)[0]
                        let paramStr = refUrl.split(`?`)[1]
                        let req = this.myaxios.post(`/api/Anonymous/Carte/RunCarteServer?type=${type}&paramStr=${paramStr}`)
                        req.then(data => {
                            refUrl = data
                            if (surgeryId && refUrl.indexOf(`@`) == -1) {
                                var w = this.screenWidth - 100
                                var h = this.screenHeight - 80
                                window.open(refUrl, ``, `width=${w},height=${h},top=10,left=10`)
                            }
                        }).catch(e => {
                            console.log(e)
                        })
                    } else {
                        var w = this.screenWidth - 100
                        var h = this.screenHeight - 80
                        window.open(refUrl, ``, `width=${w},height=${h},top=10,left=10`)
                    }
                })
                .catch(e => {
                    console.log(e)
                })
        },
        setRefurl(refUrl) {
            if (!refUrl) return null
            if (this.from != `google`) {
                refUrl = decodeURIComponent(refUrl)
            }
            let jmType = ``
            if (refUrl.indexOf(`base64_utf8`) != -1) {
                jmType = `|base64_utf8`
            }
            if (this.currentUser) {
                _.each(this.currentUser, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.visitInfo) {
                _.each(this.visitInfo, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.surgeryInfo) {
                _.each(this.surgeryInfo, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }

            if (this.hospitalward) {
                _.each(this.hospitalward, (value, key) => {
                    refUrl = refUrl.replace(`@${key}` + jmType, jmType == `` ? value : window.btoa(unescape(encodeURIComponent(value))))
                })
            }
            if (this.extralPageUrlMode == `1` && !_.includes(refUrl, `doccenter`)) {
                if (refUrl.indexOf(`?`) > -1) {
                    let refstr = refUrl.split(`?`)
                    refUrl = refstr[0] + `?` + encodeURIComponent(refUrl.replace(refstr[0] + `?`, ``))
                }
            }
            return refUrl
        }
    },
    destroyed() {
        let that = this
        that.$nextTick(() => {
            document.documentElement.removeEventListener(`fullscreenchange`, that.handleFullscreenChange)
        })
    },
    watch: {
        active_ward: function() {
            if (this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                this.dic_operating_ward_id = this.active_ward.origion
                sessionStorage.setItem(`memory_operating_ward_id`, parseInt(this.dic_operating_ward_id))
            }
        },
        dic_operating_ward_id: function(newVlaue, oldValue) {
            sessionStorage.setItem(`memory_operating_ward_id`, parseInt(newVlaue))
            let that = this
            that.selectedRoom = that.operationRoom && that.operationRoom.length > 0 && that.operationRoom[0].value
            that.refetch()
            that.$emit(`reloadLeftList`, this.dic_operating_ward_id)
        },
        selectedRoom: function(newValue, oldValue) {
            let that = this
            if (newValue != 0) {
                that.refetch()
            }
        },
        rdate: function(newData, old) {
            let calendar = this.$refs.myCalendar.getApi()
            if (this.currentView == `D` || this.currentView == `C`) {
                let first = this.$moment(newData).format(`YYYY-MM-DD`)
                calendar.gotoDate(first)
            }
            if (this.currentView == `C`) {
                let first = this.$moment(newData).format(`YYYY-MM-DD`)
                this.getOperationRooms(first)
                    .then(data => {
                        this.rooms = data
                    })
                    .catch(e => {
                        console.log(e)
                    })
            }
            this.$emit(`reloadRoomSettingWorkers`, this.rdate)
        },
        weekValue: function(newData, old) {
            let that = this
            let calendar = this.$refs.myCalendar.getApi()
            if (this.currentView == `W`) {
                let weekOfDay = that.$moment(this.weekValue).format(`E`)
                let start = that
                    .$moment(this.weekValue)
                    .subtract(weekOfDay - 1, `days`)
                    .format(`YYYY-MM-DD`)
                calendar.gotoDate(start)
            }
        },
        monthValue: function(newData, old) {
            let that = this
            let calendar = this.$refs.myCalendar.getApi()
            if (this.currentView == `M`) {
                let monthfirst = that.$moment(this.monthValue).format(`YYYY-MM-DD`)
                calendar.gotoDate(monthfirst)
            }
        },
        leftcheckedRows: function(newData, old) {
            let that = this
            for (let i = 0; i < newData.length; i++) {
                // 判断第一条为待办即可，把右侧已排程的全部取消选中
                if (newData[0].enum_surgery_status == 10) {
                    let calendar = that.$refs.myCalendar.getApi()
                    calendar.getEvents().forEach(event => {
                        event.setExtendedProp(`ischecked`, false)
                    })
                    that.selectedEvents = []
                    return
                }

                let isexist = _.findIndex(that.selectedEvents, function(t) {
                    return t.id == newData[i].id
                })
                if (isexist > -1) {
                    let calendar = this.$refs.myCalendar.getApi()
                    var event = calendar.getEventById(newData[i].id)
                    if (event) {
                        event.setExtendedProp(`ischecked`, false)
                    }
                    that.selectedEvents.splice(isexist, 1)
                    return
                }
            }
        }
    }
}
</script>
<style lang="less">
.config-column {
    width: 200px;
    overflow: hidden;
    margin: 20px 0;
}
.config-column .el-checkbox-group .el-checkbox {
    display: table-row;
}

.config-columna {
    width: 200px;
    overflow: hidden;
    margin: 20px 0;
}
.config-columna .el-checkbox-group .el-checkbox {
    display: table-row;
}
.overhidden {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.my-calendar {
    margin-top: 10px;
    text-align: center;
    background: #fff;
}
.fc .fc-toolbar-title {
    display: inline-block;
}

.surgeryStatus {
    width: 120px;
    display: inline-block;
    height: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 30px;
    color: #333333;
    opacity: 1;
    i {
        width: 16px;
        height: 16px;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }
}
.hasSetting {
    font-size: 14px;
    cursor: pointer;
}
.btnSurgeryInfocss {
    font-size: 15px;
    border: none !important;
    background-color: #ffffff !important;
    width: 17px;
    height: 17px;
    border-radius: 100% !important;
    color: var(--primary-color, #009688) !important;
    padding: 0 !important;
}
.btnSurgeryInfocss:hover {
    background-color: #ffffff !important;
    color: var(--primary-color, #009688) !important;
}
.fc-event-selected:after,
.fc-event:focus:after {
    content: '';
    background: rgba(0, 0, 0, 0) !important;
    border: solid 1px lightgrey;
}
.fc-direction-ltr .fc-timegrid-col-events {
    margin: 0 1px 0 2px !important;
}
.operationRoom {
    font-size: 14px;
    margin: 0 auto;
}
.btnchecked {
    float: right;
    margin-right: 4px;
    font-size: 6px !important;
    // width: 6px !important;
    // height: 6px !important;
    color: #ffffff !important;
    background-color: #108ee9 !important;
    border: 1px solid #ffffff !important;
    i {
        float: left;
    }
}
.padding1 {
    padding: 1px;
}
.shine {
    -webkit-animation: scaleout 2.5s infinite ease-in-out;
    animation: scaleout 2.5s infinite ease-in-out;
}
@-webkit-keyframes scaleout {
    0% {
        -webkit-transform: scale(1);
    }
    100% {
        -webkit-transform: scale(1.1);
        opacity: 0;
    }
}
@keyframes scaleout {
    0% {
        transform: scale(1);
        -webkit-transform: scale(1);
    }
    100% {
        transform: scale(1.1);
        -webkit-transform: scale(1.1);
        opacity: 0;
    }
}
.rowheight {
    height: 18px;
    line-height: 18px;
    min-width: 10px;
}

.fc-timegrid-body {
    background: white !important;
}
.fc-today {
    background: white !important;
}
.fc-day-today {
    background: white !important;
}
.fc-event {
    border-radius: 4px !important;
}
a.fc-timeline-slot-cushion {
    padding: 4px 0px 0px 0px !important;
}

.fc-resource {
    height: auto !important;
    width: auto !important;
}

.timeGridWeekHeight {
    height: 44px !important;
}
.hightColor {
    color: red;
    font: bold;
}

.fc .fc-timegrid-slot {
    height: 60px !important;
}

.fc-timegrid-event {
    display: block;
    height: auto !important;
}
.fc-event-main {
    display: block;
    height: 100% !important;
}
.fc-timeline-slot-cushion {
    display: block;
    width: 100%;
    height: 100%;
    text-align: left !important;
}
.fc-col-header-cell-cushion {
    display: block;
    width: 100%;
    height: 100%;
    font-weight: normal !important;
}
.fc-timegrid-slot-label-frame {
    position: relative !important;
    top: -20px !important;
}
.rightfloatcheck {
    position: absolute;
    right: 0px;
    bottom: 0px;
}

#calendar {
    width: 100%;
    height: 100%;
    background: #fff;
}

#calendar:-webkit-full-screen {
    width: 100%;
    height: 100%;
}

.fc-scrollgrid-sync-inner {
    height: 100%;
}
// .fc-datagrid-cell-frame {
//     height: 100% !important;
// }
// .fc-datagrid-cell-cushion {
//     height: 100% !important;
// }
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/RightScheduleSurgery.vue